(function () {
    'use strict';

    var serviceId = 'datacontext';
    angular.module('app').factory(serviceId, ['common', '_', datacontext]);

    function datacontext(common, _) {
        var $q = common.$q;
        var $http = common.$http;
        var urlAPI = '/api';
        var numRecordsTaHead = 15;    // Variabile generale di numero record per elenchi async-TypeAHead
        var _pageSize = 30;

        //Array condivisi su app - caricati su avvio app
        // Utilizzati esclusivamente su tag SELECT
        var _arrProvincie = [];

        var service = {

            arrProvincie: arrProvincie,
            getImage: getImage,

            account_get: account_get,
            account_changePassword: account_changePassword,

            //-- ATTIVITA'
            attivita_getAllList: attivita_getAllList,
            attivita_getAll: attivita_getAll,
            attivita_get: attivita_get,
            attivita_add: attivita_add,
            attivita_update: attivita_update,
            attivita_delete: attivita_delete,

            //-- AZIENDA
            azienda_getAllList: azienda_getAllList,
            azienda_getAll: azienda_getAll,
            azienda_countAll: azienda_countAll,
            azienda_get: azienda_get,
            azienda_add: azienda_add,
            azienda_update: azienda_update,
            azienda_delete: azienda_delete,

            //-- AZIENDAPARTNER
            aziendaPartner_getAllList: aziendaPartner_getAllList,
            aziendaPartner_getAll: aziendaPartner_getAll,
            aziendaPartner_countAll: aziendaPartner_countAll,
            aziendaPartner_get: aziendaPartner_get,
            aziendaPartner_add: aziendaPartner_add,
            aziendaPartner_update: aziendaPartner_update,
            aziendaPartner_delete: aziendaPartner_delete,

            //-- CLIENTE
            cliente_getAllList: cliente_getAllList,
            cliente_getAll: cliente_getAll,
            cliente_countAll: cliente_countAll,
            cliente_get: cliente_get,
            cliente_add: cliente_add,
            cliente_update: cliente_update,
            cliente_delete: cliente_delete,

            //-- CENTRO COSTO
            centroCosto_getAllList: centroCosto_getAllList,
            centroCosto_getAll: centroCosto_getAll,
            centroCosto_get: centroCosto_get,

            //-- ITEM
            item_getAllList: item_getAllList,
            item_getAll: item_getAll,
            item_get: item_get,

            //-- BUDGET COMMESSA
            budgetCommessa_get: budgetCommessa_get,
            budgetCommessa_add: budgetCommessa_add,
            budgetCommessa_update: budgetCommessa_update,
            budgetCommessa_delete: budgetCommessa_delete,

            //-- COMMESSA
            commessa_getAllList: commessa_getAllList,
            commessa_getAllByFilter: commessa_getAllByFilter,
            commessa_countAll: commessa_countAll,
            commessa_getAllListForOfferte: commessa_getAllListForOfferte,
            commessa_getAllForOfferte: commessa_getAllForOfferte,
            commessa_countAllForOfferte: commessa_countAllForOfferte,
            commessa_getAllListForTimeSheet: commessa_getAllListForTimeSheet,
            commessa_getAllForTimeSheet: commessa_getAllForTimeSheet,
            commessa_countAllForTimeSheet: commessa_countAllForTimeSheet,
            commessa_get: commessa_get,
            commessa_getMaxCodiceCommessa: commessa_getMaxCodiceCommessa,
            commessa_add: commessa_add,
            commessa_update: commessa_update,
            commessa_delete: commessa_delete,
            commessa_aggiornaStato: commessa_aggiornaStato,
            commessa_riapriCommessa: commessa_riapriCommessa,
            commessa_chiudiCommessa: commessa_chiudiCommessa,
            commessa_checkTeamLeader: commessa_checkTeamLeader,

            //COMMESSA SEZIONE
            commessaSezione_getAll: commessaSezione_getAll,
            commessaSezione_getAllForTimeSheet: commessaSezione_getAllForTimeSheet,
            commessaSezione_add: commessaSezione_add,
            commessaSezione_addList: commessaSezione_addList,
            commessaSezione_update: commessaSezione_update,
            commessaSezione_delete: commessaSezione_delete,

            //-- SYNCORELOG
            syncOreLog_getAllList: syncOreLog_getAllList,
            syncOreLog_getAllByFilter: syncOreLog_getAllByFilter,
            syncOreLog_countAll: syncOreLog_countAll,
            syncOreLog_editSync: syncOreLog_editSync,

            //-- COSTO DIPENDENTE
            costoDipendente_get: costoDipendente_get,
            costoDipendente_add: costoDipendente_add,
            costoDipendente_update: costoDipendente_update,
            costoDipendente_delete: costoDipendente_delete,

            //-- Profilo DIPENDENTi
            profiloDipendenti_get: profiloDipendenti_get,
            profiloDipendenti_getByDipendenteId: profiloDipendenti_getByDipendenteId,
            profiloDipendenti_add: profiloDipendenti_add,
            profiloDipendenti_update: profiloDipendenti_update,
            profiloDipendenti_delete: profiloDipendenti_delete,

            //-- DASHBOARD 
            dashboard_get: dashboard_get,

            //-- DIPENDENTE
            dipendente_getAllList: dipendente_getAllList,
            dipendente_getAll: dipendente_getAll,
            dipendente_getAllNonAttivi: dipendente_getAllNonAttivi,
            dipendente_countAll: dipendente_countAll,
            dipendente_getAllForCommessa: dipendente_getAllForCommessa,
            dipendente_countAllForCommessa: dipendente_countAllForCommessa,
            dipendente_getAllByAziendaPartner: dipendente_getAllByAziendaPartner,
            dipendente_get: dipendente_get,
            dipendente_add: dipendente_add,
            dipendente_update: dipendente_update,
            dipendente_delete: dipendente_delete,            
            dipendente_stampaCurriculum: dipendente_stampaCurriculum,
            dipendente_getAllByDB: dipendente_getAllByDB,

            //-- DIPENDENTE CON RUOLO
            dipendenteConRuolo_getAll: dipendenteConRuolo_getAll,
            dipendenteConRuolo_countAll: dipendenteConRuolo_countAll,

            //DIPENDENTE SEZIONE
            dipendenteSezione_getAll: dipendenteSezione_getAll,
            dipendenteSezione_add: dipendenteSezione_add,
            dipendenteSezione_addList: dipendenteSezione_addList,
            dipendenteSezione_delete: dipendenteSezione_delete,

            //-- DETTAGLIO DIPENDENTE
            dettaglioDipendente_getAllList: dettaglioDipendente_getAllList,
            dettaglioDipendente_getAll: dettaglioDipendente_getAll,
            dettaglioDipendente_countAll: dettaglioDipendente_countAll,
            dettaglioDipendente_get: dettaglioDipendente_get,

            //-- ISTRUZIONE
            istruzione_getAll: istruzione_getAll,
            istruzione_add: istruzione_add,
            istruzione_addList: istruzione_addList,
            istruzione_update: istruzione_update,
            istruzione_changeSequence: istruzione_changeSequence,
            istruzione_delete: istruzione_delete,
            istruzione_get: istruzione_get,

            //-- FORMAZIONE
            formazione_getAll: formazione_getAll,
            formazione_add: formazione_add,
            formazione_update: formazione_update,
            formazione_changeSequence: formazione_changeSequence,
            formazione_delete: formazione_delete,
            formazione_get: formazione_get,

            //-- DETTAGLIO PROGETTO
            dettaglioProgetto_getAll: dettaglioProgetto_getAll,
            dettaglioProgetto_add: dettaglioProgetto_add,
            dettaglioProgetto_update: dettaglioProgetto_update,
            dettaglioProgetto_changeSequence: dettaglioProgetto_changeSequence,
            dettaglioProgetto_delete: dettaglioProgetto_delete,
            dettaglioProgetto_get: dettaglioProgetto_get,

            //-- ESPERIENZA LAVORATIVA
            esperienzaLavorativa_getAll: esperienzaLavorativa_getAll,
            esperienzaLavorativa_add: esperienzaLavorativa_add,
            esperienzaLavorativa_update: esperienzaLavorativa_update,
            esperienzaLavorativa_changeSequence: esperienzaLavorativa_changeSequence,
            esperienzaLavorativa_delete: esperienzaLavorativa_delete,
            esperienzaLavorativa_get: esperienzaLavorativa_get,

            //-- FASE CURRICULUM
            faseCurriculum_getAll: faseCurriculum_getAll,
            faseCurriculum_get: faseCurriculum_get,

            //-- SOFTWARE
            software_getAll: software_getAll,
            software_add: software_add,
            software_addList: software_addList,
            software_update: software_update,
            software_delete: software_delete,
            software_get: software_get,

            //-- COMPETENZA DIGITALE
            competenzaDigitale_getAll: competenzaDigitale_getAll,
            competenzaDigitale_add: competenzaDigitale_add,
            competenzaDigitale_update: competenzaDigitale_update,
            competenzaDigitale_delete: competenzaDigitale_delete,
            competenzaDigitale_get: competenzaDigitale_get,

            //-- COMPETENZA TECNICA
            competenzaTecnica_getAll: competenzaTecnica_getAll,
            competenzaTecnica_add: competenzaTecnica_add,
            competenzaTecnica_update: competenzaTecnica_update,
            competenzaTecnica_delete: competenzaTecnica_delete,
            competenzaTecnica_get: competenzaTecnica_get,

            //-- LINGUA
            lingua_getAll: lingua_getAll,
            lingua_add: lingua_add,
            lingua_update: lingua_update,
            lingua_delete: lingua_delete,
            lingua_get: lingua_get,

            //-- LINGUAGGIO PROGRAMMAZIONE
            linguaggioProgrammazione_getAll: linguaggioProgrammazione_getAll,
            linguaggioProgrammazione_add: linguaggioProgrammazione_add,
            linguaggioProgrammazione_addList: linguaggioProgrammazione_addList,
            linguaggioProgrammazione_update: linguaggioProgrammazione_update,
            linguaggioProgrammazione_delete: linguaggioProgrammazione_delete,
            linguaggioProgrammazione_get: linguaggioProgrammazione_get,

            //-- NORMA
            norma_getAll: norma_getAll,
            norma_add: norma_add,
            norma_addList: norma_addList,
            norma_update: norma_update,
            norma_delete: norma_delete,
            norma_get: norma_get,

            //-- STANDARD
            standard_getAll: standard_getAll,
            standard_add: standard_add,
            standard_addList: standard_addList,
            standard_update: standard_update,
            standard_delete: standard_delete,
            standard_get: standard_get,

            //-- AREA TECNICA
            areaTecnica_getAllList: areaTecnica_getAllList,
            areaTecnica_get: areaTecnica_get,

            //-- TIPO ATTIVITA
            tipoAttivita_getAllList: tipoAttivita_getAllList,
            tipoAttivita_getAllByAreaTecnicaId: tipoAttivita_getAllByAreaTecnicaId,
            tipoAttivita_getAll: tipoAttivita_getAll,
            tipoAttivita_countAll: tipoAttivita_countAll,
            tipoAttivita_add: tipoAttivita_add,
            tipoAttivita_delete: tipoAttivita_delete,
            tipoAttivita_get: tipoAttivita_get,
            tipoAttivita_update: tipoAttivita_update,

            //-- TIPO ASSEGNAZIONE
            tipoAssegnazione_getAllList: tipoAssegnazione_getAllList,

            //-- TIPO PRESTAZIONE
            tipoPrestazione_getAllList: tipoPrestazione_getAllList,

            //-- TIPO LINGUAGGIO
            tipoLinguaggio_getAllList: tipoLinguaggio_getAllList,
            tipoLinguaggio_getAll: tipoLinguaggio_getAll,
            tipoLinguaggio_countAll: tipoLinguaggio_countAll,
            tipoLinguaggio_add: tipoLinguaggio_add,
            tipoLinguaggio_delete: tipoLinguaggio_delete,
            tipoLinguaggio_get: tipoLinguaggio_get,
            tipoLinguaggio_update: tipoLinguaggio_update,

            //-- TIPO MANSIONE
            tipoMansione_getAllList: tipoMansione_getAllList,
            tipoMansione_getAllByAreaTecnicaId: tipoMansione_getAllByAreaTecnicaId,
            tipoMansione_getAll: tipoMansione_getAll,
            tipoMansione_countAll: tipoMansione_countAll,
            tipoMansione_add: tipoMansione_add,
            tipoMansione_delete: tipoMansione_delete,
            tipoMansione_get: tipoMansione_get,
            tipoMansione_update: tipoMansione_update,

            //-- TIPO NORMA
            tipoNorma_getAllList: tipoNorma_getAllList,
            tipoNorma_getAll: tipoNorma_getAll,
            tipoNorma_countAll: tipoNorma_countAll,
            tipoNorma_add: tipoNorma_add,
            tipoNorma_delete: tipoNorma_delete,
            tipoNorma_get: tipoNorma_get,
            tipoNorma_update: tipoNorma_update,

            //-- TIPO SERVIZIO EN
            tipoServizioEn_getAll: tipoServizioEn_getAll,

            //-- TIPO SOFTWARE
            tipoSoftware_getAllList: tipoSoftware_getAllList,
            tipoSoftware_getAllByAreaTecnicaId: tipoSoftware_getAllByAreaTecnicaId,
            tipoSoftware_getAll: tipoSoftware_getAll,
            tipoSoftware_countAll: tipoSoftware_countAll,
            tipoSoftware_add: tipoSoftware_add,
            tipoSoftware_delete: tipoSoftware_delete,
            tipoSoftware_get: tipoSoftware_get,
            tipoSoftware_update: tipoSoftware_update,

            //-- TIPO STANDARD
            tipoStandard_getAllList: tipoStandard_getAllList,
            tipoStandard_getAll: tipoStandard_getAll,
            tipoStandard_countAll: tipoStandard_countAll,
            tipoStandard_add: tipoStandard_add,
            tipoStandard_delete: tipoStandard_delete,
            tipoStandard_get: tipoStandard_get,
            tipoStandard_update: tipoStandard_update,

            //TEAM
            team_countAll: team_countAll,
            team_getAll: team_getAll,
            team_update: team_update,
            team_add: team_add,
            team_get: team_get,
            team_delete: team_delete,

            //DIPENDENTITEAM
            dipendentiTeam_getAll: dipendentiTeam_getAll,
            dipendentiTeam_add: dipendentiTeam_add,
            dipendentiTeam_delete: dipendentiTeam_delete,

            //DIPENDENTICOMMESSA
            dipendentiCommessa_getAll: dipendentiCommessa_getAll,
            dipendentiCommessa_add: dipendentiCommessa_add,
            dipendentiCommessa_addList: dipendentiCommessa_addList,
            dipendentiCommessa_delete: dipendentiCommessa_delete,

            //COSTI BASE
            costiBase_countAll: costiBase_countAll,
            costiBase_getAll: costiBase_getAll,
            costiBase_update: costiBase_update,
            costiBase_add: costiBase_add,
            costiBase_get: costiBase_get,
            costiBase_getDefault: costiBase_getDefault,
            costiBase_delete: costiBase_delete,

            //-- GIUSTIFICATIVO
            giustificativo_getAllList: giustificativo_getAllList,
            giustificativo_getAll: giustificativo_getAll,
            giustificativo_countAll: giustificativo_countAll,
            giustificativo_get: giustificativo_get,
            giustificativo_add: giustificativo_add,
            giustificativo_update: giustificativo_update,
            giustificativo_delete: giustificativo_delete,

            //-- PUSH NOTIFICATION
            pushNotification_add: pushNotification_add,

            //-- PROFILO ORE
            profiloOre_get: profiloOre_get,
            profiloOre_getAllList: profiloOre_getAllList,

            profiloOre_countAll: profiloOre_countAll,
            profiloOre_getAll: profiloOre_getAll,
            profiloOre_update: profiloOre_update,
            profiloOre_add: profiloOre_add,
            //profiloOre_get: profiloOre_get,
            profiloOre_delete: profiloOre_delete,


            //-- REPORT
            report_getPresenze: report_getPresenze,
            report_getTimeSheetMensile: report_getTimeSheetMensile,
            report_getTimeSheetMensileDipendenti: report_getTimeSheetMensileDipendenti,
            report_getTimeSheet: report_getTimeSheet,
            report_getCosti: report_getCosti,
            report_getCommesse: report_getCommesse,
            report_getVerificaTimeSheet: report_getVerificaTimeSheet,
            report_getTotaliCommSez: report_getTotaliCommSez,
            report_getTotaliSezDip: report_getTotaliSezDip,
            report_getTotaliSezioni: report_getTotaliSezioni,
            report_getDipendenti: report_getDipendenti,
            report_Commessa: report_Commessa,
            report_getFerie: report_getFerie,

            //-- REPORT ORE
            reportOre_getAll: reportOre_getAll,
            reportOre_countAll: reportOre_countAll,
            reportOre_getSum: reportOre_getSum,
            reportOre_getTotale: reportOre_getTotale,

            //-- RichiestaFerie
            richiestaFerie_getAllList: richiestaFerie_getAllList,
            richiestaFerie_getAllByFilter: richiestaFerie_getAllByFilter,
            richiestaFerie_countAll: richiestaFerie_countAll,
            richiestaFerie_getReportFerie: richiestaFerie_getReportFerie,
            richiestaFerie_getValidFerie: richiestaFerie_getValidFerie,
            richiestaFerie_get: richiestaFerie_get,
            richiestaFerie_addMultiplo: richiestaFerie_addMultiplo,
            richiestaFerie_add: richiestaFerie_add,
            richiestaFerie_update: richiestaFerie_update,
            richiestaFerie_inoltra: richiestaFerie_inoltra,
            richiestaFerie_delete: richiestaFerie_delete,

            //-- ValidazioneRichiestaFerie
            validazioneRichiestaFerie_getAllValid: validazioneRichiestaFerie_getAllValid,
            validazioneRichiestaFerie_countValid: validazioneRichiestaFerie_countValid,
            validazioneRichiestaFerie_accetta: validazioneRichiestaFerie_accetta,
            validazioneRichiestaFerie_rifiuta: validazioneRichiestaFerie_rifiuta,

            //-- TIMESHEET
            timeSheet_getAll: timeSheet_getAll,
            timeSheet_getById: timeSheet_getById,
            timeSheet_get: timeSheet_get,
            timeSheet_getMensile: timeSheet_getMensile,
            timeSheet_save: timeSheet_save,
            timeSheet_delete: timeSheet_delete,
            timeSheet_getRiepilogo: timeSheet_getRiepilogo,
            timeSheet_getRiepilogoSettimanale: timeSheet_getRiepilogoSettimanale,
            timeSheet_getWeek: timeSheet_getWeek,
            timeSheet_getWeekByDate: timeSheet_getWeekByDate,
            timeSheet_getDate: timeSheet_getDate,
            timeSheet_getDatesOfWeek: timeSheet_getDatesOfWeek,

            //-- SETTINGS
            settings_getAll: settings_getAll,
            settings_countAll: settings_countAll,
            settings_get: settings_get,
            settings_add: settings_add,
            settings_update: settings_update,
            settings_delete: settings_delete,

            //-- SEZIONI
            sezione_getAllList: sezione_getAllList,
            sezione_getAll: sezione_getAll,
            sezione_countAll: sezione_countAll,
            sezione_getAllListForTimeSheet: sezione_getAllListForTimeSheet,
            sezione_getAllForTimeSheet: sezione_getAllForTimeSheet,
            sezione_get: sezione_get,
            sezione_add: sezione_add,
            sezione_update: sezione_update,
            sezione_delete: sezione_delete,

            //-- VALIDAZIONE TIMESHEET
            validazioneTimeSheet_getAll: validazioneTimeSheet_getAll,
            validazioneTimeSheet_countAll: validazioneTimeSheet_countAll,
            validazioneTimeSheet_convalida: validazioneTimeSheet_convalida,
            validazioneTimeSheet_notificaTutti: validazioneTimeSheet_notificaTutti,

            //-- ISTAT
            istat_comune_getAllList: istat_comune_getAllList,
            istat_comune_get: istat_comune_get,

            //-- USER
            user_getAll: user_getAll,
            user_getAllList: user_getAllList,
            user_getAllUsernames: user_getAllUsernames,
            user_countAll: user_countAll,
            user_get: user_get,
            user_getByUsername: user_getByUsername,
            user_getByDipendenteId: user_getByDipendenteId,
            user_add: user_add,
            user_update: user_update,
            user_activate: user_activate,
            user_deactivate: user_deactivate,
            user_resetPassword: user_resetPassword,
            user_invioCredenziali: user_invioCredenziali,
            user_delete: user_delete,
            user_suggestUserame: user_suggestUserame,
            user_suggestPassword: user_suggestPassword,

            //-- SUPER_USER
            super_user_getAll: super_user_getAll,
            super_user_countAll: super_user_countAll,

            //-- ROLE
            role_getAll: role_getAll,
            role_get: role_get,
            role_getAllList: role_getAllList,

            //-- ROLE USER
            userRole_getAll: userRole_getAll,
            userRole_add: userRole_add,
            userRole_delete: userRole_delete,

            //SYSTEM METHOD
            getWhoAmI: getWhoAmI,
            logGetAll: logGetAll,
            logDelete: logDelete,
            pushGetAll: pushGetAll,
            pushDelete: pushDelete,
            festivita_getAll: festivita_getAll,

            //-- ATTIVITA' CONTROLLO
            //attivitaControllo_getAllList: attivita_getAllList,
            //attivitaControllo_getAll: attivita_getAll,


            attivitaControllo_countAll: attivitaControllo_countAll,
            attivitaControllo_getAllByFilter: attivitaControllo_getAllByFilter,
            attivitaControllo_get: attivita_get,
            /*
            commessa_getAllList: commessa_getAllList,
            commessa_getAllByFilter: commessa_getAllByFilter,
            commessa_countAll: commessa_countAll,
            syncCommessa_countAll: syncCommessa_countAll,
            syncCommessa_getAllByFilter: syncCommessa_getAllByFilter,
            commessa_sync: commessa_sync,
            commessa_get: commessa_get,
            */

            //AUTHORIZATION
            authorization_get: authorization_get,
            authorization_getAllByFilter: authorization_getAllByFilter,
            authorization_countByFilter: authorization_countByFilter,
            authorization_add: authorization_add,
            authorization_update: authorization_update,
            authorization_delete: authorization_delete,

            //-- ATTACH - Nuovi Metodi
            attach_getAllList: attach_getAllList,
            attach_getAll: attach_getAll,
            attach_countAll: attach_countAll,
            attach_get: attach_get,
            attach_add: attach_add,
            attach_update: attach_update,
            attach_delete: attach_delete,
            attach_setCompleted: attach_setCompleted,
            attach_unsetCompleted: attach_unsetCompleted,

            //Estrazione documentazione dalla piattaforma
            attach_download: attach_download,
            attach_extract: attach_extract,
            upload_getURL: upload_getURL,

            //-- TATTACH          
            tAttach_getAllList: tAttach_getAllList,
            tAttach_getAllModal: tAttach_getAllModal,
            tAttach_getAll: tAttach_getAll,
            tAttach_countAll: tAttach_countAll,
            tAttach_get: tAttach_get,
            tAttach_add: tAttach_add,
            tAttach_update: tAttach_update,
            tAttach_delete: tAttach_delete,

            //-- TATTACHVISIBILITY
            tAttachVisibility_getAuth: tAttachVisibility_getAuth,
            tAttachVisibility_getAll: tAttachVisibility_getAll,
            tAttachVisibility_add: tAttachVisibility_add,
            tAttachVisibility_update: tAttachVisibility_update,
            tAttachVisibility_delete: tAttachVisibility_delete,

            //-- TATTACHFILETYPE
            tAttachFileType_getAll: tAttachFileType_getAll,
            tAttachFileType_add: tAttachFileType_add,
            tAttachFileType_update: tAttachFileType_update,
            tAttachFileType_delete: tAttachFileType_delete,

            //-- TSOURCE          
            tSource_getAllList: tSource_getAllList,
            tSource_getAll: tSource_getAll,
            tSource_get: tSource_get,
            tSource_getByCode: tSource_getByCode
        };
        return service;

        // ***************************************************
        // ***************************************************
        //  Funzioni Pubbliche - esposte su interfaccia Service
        // ***************************************************
        // ***************************************************
        //  Metodi init per array condivisi
        function arrProvincie() {
            if (_arrProvincie.length == 0) {
                return getAll('provincia').then(function (data) {
                    _arrProvincie = data;
                    return _arrProvincie;
                });
            }
            return $q.when(_arrProvincie);
        }

        function getImage(imagePath) {
            return $http.get(imagePath)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    return null;
                });
        }

        // ******************************
        //  ACCOUNT
        function account_get() {
            return $http.get(urlAPI + '/account/get').then(function (response) {
                return response.data;
            })
                .catch(function (response) {
                    console.log('XHR Failed account_get: %s', response); return null;
                });
        }


        function account_changePassword(item) {
            return $http.post(urlAPI + '/account/ChangePassword', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    console.log('XHR Failed account_changePassword: %s', response);
                    return response;
                });
        }

        // ******************************
        //  ATTIVITA'
        function attivita_getAllList(commessaId) {
            if (typeof (commessaId) == 'undefined') { commessaId = sezioneId; }

            var params = [];
            params.push({ name: 'sezioneId', value: sezioneId });

            var data = getAllByParams('Attivita', 'GetAllList', params);
            return $q.when(data);
        }

        function attivita_getAll(commessaId) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });

            var data = getAllByParams('Attivita', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function attivita_get(id) {
            var data = getById('Attivita', id);
            return $q.when(data);
        }

        function attivita_add(item) {
            var data = addObj('Attivita', item);
            return $q.when(data);
        }

        function attivita_update(item) {
            var data = updateObj('Attivita', item);
            return $q.when(data);
        }

        function attivita_delete(id) {
            var data = deleteObj('Attivita', id);
            return $q.when(data);
        }

        // ******************************
        //  AZIENDAPARTNER
        function aziendaPartner_getAllList() {
            var data = getAllNoParam('AziendaPartner', 'GetAllList');
            return $q.when(data);
        }

        function aziendaPartner_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('AziendaPartner', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function aziendaPartner_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('AziendaPartner', 'CountByFilter', params);
            return $q.when(data);
        }

        function aziendaPartner_get(id) {
            var data = getById('AziendaPartner', id);
            return $q.when(data);
        }

        function aziendaPartner_add(item) {
            var data = addObj('AziendaPartner', item);
            return $q.when(data);
        }

        function aziendaPartner_update(item) {
            var data = updateObj('AziendaPartner', item);
            return $q.when(data);
        }

        function aziendaPartner_delete(id) {
            var data = deleteObj('AziendaPartner', id);
            return $q.when(data);
        }

        // ******************************
        //  AZIENDA
        function azienda_getAllList() {
            var data = getAllNoParam('Azienda', 'GetAllList');
            return $q.when(data);
        }

        function azienda_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Azienda', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function azienda_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('Azienda', 'CountByFilter', params);
            return $q.when(data);
        }

        function azienda_get(id) {
            var data = getById('Azienda', id);
            return $q.when(data);
        }

        function azienda_add(item) {
            var data = addObj('Azienda', item);
            return $q.when(data);
        }

        function azienda_update(item) {
            var data = updateObj('Azienda', item);
            return $q.when(data);
        }

        function azienda_delete(id) {
            var data = deleteObj('Azienda', id);
            return $q.when(data);
        }

        // ******************************
        //  CLIENTE
        function cliente_getAllList() {
            var data = getAllNoParam('Cliente', 'GetAllList');
            return $q.when(data);
        }

        function cliente_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Cliente', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function cliente_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('Cliente', 'CountByFilter', params);
            return $q.when(data);
        }

        function cliente_get(id) {
            var data = getById('Cliente', id);
            return $q.when(data);
        }

        function cliente_add(item) {
            var data = addObj('Cliente', item);
            return $q.when(data);
        }

        function cliente_update(item) {
            var data = updateObj('Cliente', item);
            return $q.when(data);
        }

        function cliente_delete(id) {
            var data = deleteObj('Cliente', id);
            return $q.when(data);
        }

        // ******************************
        //  BUDGET COMMESSA
        function budgetCommessa_get(id) {
            var data = getById('BudgetCommessa', id);
            return $q.when(data);
        }

        function budgetCommessa_add(item) {
            var data = addObj('BudgetCommessa', item);
            return $q.when(data);
        }

        function budgetCommessa_update(item) {
            var data = updateObj('BudgetCommessa', item);
            return $q.when(data);
        }

        function budgetCommessa_delete(item) {
            var data = deleteObj('BudgetCommessa', item);
            return $q.when(data);
        }


        // ******************************
        //  COMMESSA
        function commessa_getAllList() {

            var data = getAllNoParam('Commessa', 'GetAllList');
            return $q.when(data);
        }

        function commessa_getAllByFilter(pageSize, page, ricerca, clienteId, stato, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = -1; }
            if (typeof (clienteId) == 'undefined') { clienteId = 0; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'clienteId', value: clienteId });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Commessa', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function commessa_countAll(ricerca, clienteId, stato) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (clienteId) == 'undefined') { clienteId = 0; }
            if (typeof (stato) == 'undefined') { stato = -1; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'clienteId', value: clienteId });
            params.push({ name: 'stato', value: stato });

            var data = getAllByParams('Commessa', 'CountByFilter', params);
            return $q.when(data);
        }

        function commessa_getAllListForOfferte() {

            var data = getAllNoParam('Offerta', 'GetAllListForOfferte');
            return $q.when(data);
        }

        function commessa_getAllForOfferte(pageSize, page, ricerca, clienteId, stato, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = -1; }
            if (typeof (clienteId) == 'undefined') { clienteId = 0; }
            if (typeof (stato) == 'undefined') { stato = -1; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'clienteId', value: clienteId });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'order', value: order });
            var data = getAllByParams('Offerta', 'GetAllByFilter', params);
            return $q.when(data);

        }

        function commessa_countAllForOfferte(ricerca, clienteId, stato) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (clienteId) == 'undefined') { clienteId = 0; }
            if (typeof (stato) == 'undefined') { stato = -1; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'clienteId', value: clienteId });
            params.push({ name: 'stato', value: stato });
            var data = getAllByParams('Offerta', 'CountByFilter', params);
            return $q.when(data);
        }

        function commessa_getAllListForTimeSheet() {

            var data = getAllNoParam('Commessa', 'GetAllListForTimeSheet');
            return $q.when(data);
        }

        function commessa_getAllForTimeSheet(pageSize, page, ricerca, clienteId, stato, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = -1; }
            if (typeof (clienteId) == 'undefined') { clienteId = 0; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'clienteId', value: clienteId });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Commessa', 'GetAllForTimeSheet', params);
            return $q.when(data);
        }

        function commessa_countAllForTimeSheet(ricerca, clienteId, stato) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (clienteId) == 'undefined') { clienteId = 0; }
            if (typeof (stato) == 'undefined') { stato = -1; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'clienteId', value: clienteId });
            params.push({ name: 'stato', value: stato });

            var data = getAllByParams('Commessa', 'CountForTimeSheet', params);
            return $q.when(data);
        }

        function commessa_get(id) {
            var data = getById('Commessa', id);
            return $q.when(data);
        }

        function commessa_getMaxCodiceCommessa() {
            var data = getAllNoParam('Commessa', 'GetMaxCodiceCommessa');
            return $q.when(data);
        }

        function commessa_add(item) {
            var data = addObj('Commessa', item);
            return $q.when(data);
        }

        function commessa_update(item) {
            var data = updateObj('Commessa', item);
            return $q.when(data);
        }

        function commessa_delete(id) {
            var data = deleteObj('Commessa', id);
            return $q.when(data);
        }

        function commessa_checkTeamLeader(id) {
            if (typeof (id) == 'undefined') { id = 0; }

            var data = getAllByParam('Commessa', 'CheckTeamLeaderCommessa', 'id', id);
            return $q.when(data);
        }

        function commessa_aggiornaStato(commessaId, stato) {
            var objName = 'Commessa';
            var method = 'AggiornaStatoCommessa';

            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (stato) == 'undefined') { stato = 0; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                CommessaId: commessaId,
                Stato: stato
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function commessa_chiudiCommessa(item) {
            var objName = 'Commessa';
            var method = 'ChiudiCommessa';
            var url = urlAPI + '/' + objName + '/' + method;

            return $http.put(url, item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed commessa_chiudiCommessa for %s: %s', objName, message);
                    return message.status;
                });
        }

        function commessa_riapriCommessa(item) {
            var objName = 'Commessa';
            var method = 'RiapriCommessa';
            var url = urlAPI + '/' + objName + '/' + method;

            return $http.put(url, item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed commessa_riapriCommessa for %s: %s', objName, message);
                    return message.status;
                });
        }

        // ******************************
        //Dipendente Sezione
        function commessaSezione_getAll(commessaId, sezioneId) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (sezioneId) == 'undefined') { sezioneId = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'sezioneId', value: sezioneId });

            var data = getAllByParams('CommessaSezione', 'GetAll', params);
            return $q.when(data);
        }

        function commessaSezione_getAllForTimeSheet(commessaId) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });

            var data = getAllByParams('CommessaSezione', 'GetAllForTimeSheet', params);
            return $q.when(data);
        }

        function commessaSezione_add(commessaId, sezioneId) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (sezioneId) == 'undefined') { sezioneId = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'sezioneId', value: sezioneId });


            var objName = 'CommessaSezione';
            var actionName = 'AddCommessaSezione';
            var url = urlAPI + '/' + objName + '/' + actionName;

            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;

            }

            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });

        }

        function commessaSezione_addList(commessaId, sezioni) {
            var objName = 'CommessaSezione';
            var method = 'AddList';

            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (sezioni) == 'undefined') { sezioni = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                commessaId: commessaId,
                sezioni: sezioni
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function commessaSezione_update(item) {
            var data = updateObj('CommessaSezione', item);
            return $q.when(data);
        }

        function commessaSezione_delete(item) {
            var data = deleteObj('CommessaSezione', item);
            return $q.when(data);
        }

        // ******************************
        //  SYNCORELOG

        function syncOreLog_getAllList(commessaId) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });

            var data = getAllByParams('SyncOreLog', 'GetAllList', params);
            return $q.when(data);
        }

        function syncOreLog_getAllByFilter(commessaId, ricerca, stato, data) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (data) == 'undefined') { data = ''; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'data', value: data });

            var data = getAllByParams('SyncOreLog', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function syncOreLog_countAll(commessaId, ricerca, stato, data) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (data) == 'undefined') { data = ''; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'data', value: data });

            var data = getAllByParams('SyncOreLog', 'CountByFilter', params);
            return $q.when(data);
        }

        function syncOreLog_editSync(oreId, valore) {
            if (typeof (oreId) == 'undefined') { oreId = 0; }
            if (typeof (valore) == 'undefined') { valore = 0; }

            return $http.put(urlAPI + '/SyncOreLog/EditSync?oreId=' + oreId + '&valore=' + valore)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed syncOreLog_editSync: %s', message);
                    return message.status;
                });
        }

        // ******************************
        //  CENTRO COSTO
        function centroCosto_getAllList(itemId, stato) {
            if (typeof (itemId) == 'undefined') { itemId = -1; }
            if (typeof (stato) == 'undefined') { stato = 0; }

            var params = [];
            params.push({ name: 'itemId', value: itemId });
            params.push({ name: 'stato', value: stato });

            var data = getAllByParams('CentroCosto', 'GetAllList', params);
            return $q.when(data);
        }

        function centroCosto_getAll(itemId, stato) {
            if (typeof (itemId) == 'undefined') { itemId = -1; }
            if (typeof (stato) == 'undefined') { stato = 0; }

            var params = [];
            params.push({ name: 'itemId', value: itemId });
            params.push({ name: 'stato', value: stato });

            var data = getAllByParams('CentroCosto', 'GetAll', params);
            return $q.when(data);
        }

        function centroCosto_get(id) {
            var data = getById('CentroCosto', id);
            return $q.when(data);
        }

        // ******************************
        //  ITEM
        function item_getAllList(commessaId, stato) {
            if (typeof (commessaId) == 'undefined') { commessaId = -1; }
            if (typeof (stato) == 'undefined') { stato = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'stato', value: stato });

            //var data = getAllByParam('Item', 'GetAllList', 'commessaId', commessaId);
            var data = getAllByParams('Item', 'GetAllList', params);
            return $q.when(data);
        }

        function item_getAll(commessaId, stato) {
            if (typeof (commessaId) == 'undefined') { commessaId = -1; }
            if (typeof (stato) == 'undefined') { stato = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'stato', value: stato });

            //var data = getAllByParam('Item', 'GetAll', 'commessaId', commessaId);
            var data = getAllByParams('Item', 'GetAll', params);
            return $q.when(data);
        }

        function item_get(id) {
            var data = getById('Item', id);
            return $q.when(data);
        }

        // ******************************
        //  COSTO DIPENDENTE
        function costoDipendente_get(id) {
            var data = getById('CostoDipendente', id);
            return $q.when(data);
        }

        function costoDipendente_add(item) {
            var data = addObj('CostoDipendente', item);
            return $q.when(data);
        }

        function costoDipendente_update(item) {
            var data = updateObj('CostoDipendente', item);
            return $q.when(data);
        }

        function costoDipendente_delete(item) {
            var data = deleteObj('CostoDipendente', item);
            return $q.when(data);
        }

        // ******************************


        // ******************************
        //  DASHBOARD 
        function dashboard_get() {
            var data = getAllNoParam('Dashboard', 'Get');
            return $q.when(data);
        }

        // ******************************
        //  DIPENDENTE
        function dipendente_getAllList(stato, aziendaPartnerId) {
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Dipendente', 'GetAllList', params);
            return $q.when(data);
        }

        function dipendente_getAll(pageSize, page, stato, ricerca, aziendaPartnerId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Dipendente', 'GetAll', params);
            return $q.when(data);
        }

        function dipendente_getAllNonAttivi(matricola) {
            if (typeof (matricola) == 'undefined') { matricola = ''; }

            var params = [];
            params.push({ name: 'matricola', value: matricola });

            var data = getAllByParams('Dipendente', 'GetAllNonAttivi', params);
            return $q.when(data);
        }

        function dipendente_countAll(stato, ricerca, aziendaPartnerId) {
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Dipendente', 'CountAll', params);
            return $q.when(data);
        }

        function dipendente_getAllForCommessa(pageSize, page, stato, ricerca, aziendaPartnerId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Dipendente', 'GetAllForCommessa', params);
            return $q.when(data);
        }

        function dipendente_countAllForCommessa(stato, ricerca, aziendaPartnerId) {
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Dipendente', 'CountAllForCommessa', params);
            return $q.when(data);
        }

        function dipendente_getAllByAziendaPartner(aziendaPartnerId) {
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Dipendente', 'GetAllByAziendaPartner', params);
            return $q.when(data);
        }

        function dipendente_get(id) {
            var data = getById('Dipendente', id);
            return $q.when(data);
        }

        function dipendente_add(item) {
            var data = addObj('Dipendente', item);
            return $q.when(data);
        }

        function dipendente_update(item) {
            var data = updateObj('Dipendente', item);
            return $q.when(data);
        }

        function dipendente_delete(id) {
            var data = deleteObj('Dipendente', id);
            return $q.when(data);
        }        

        function dipendente_stampaCurriculum(dipendenteId, withAttach, withSignature, dataStampa, withLogo, withAddress, withBusinessPhone, withMobilePhone, rev, dataRev) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (withAttach) == 'undefined') { withAttach = false; }
            if (typeof (withSignature) == 'undefined') { withSignature = true; }
            if (typeof (dataStampa) == 'undefined') { dataStampa = '' }
            if (typeof (withLogo) == 'undefined') { withLogo = true; }
            if (typeof (withAddress) == 'undefined') { withAddress = true; }
            if (typeof (withBusinessPhone) == 'undefined') { withBusinessPhone = true; }
            if (typeof (withMobilePhone) == 'undefined') { withMobilePhone = true; }
            if (typeof (rev) == 'undefined') { rev = -1; }
            if (typeof (dataRev) == 'undefined') { dataRev = ''; }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'withAttach', value: withAttach });
            params.push({ name: 'withSignature', value: withSignature });
            params.push({ name: 'dataStampa', value: dataStampa });
            params.push({ name: 'withLogo', value: withLogo });
            params.push({ name: 'withAddress', value: withAddress });
            params.push({ name: 'withBusinessPhone', value: withBusinessPhone });
            params.push({ name: 'withMobilePhone', value: withMobilePhone });
            params.push({ name: 'rev', value: rev });
            params.push({ name: 'dataRev', value: dataRev });

            var data = getAllByParams('Dipendente', 'StampaCurriculum', params);
            return $q.when(data);
        }

        function dipendente_getAllByDB(db) {
            if (typeof (db) == 'undefined') { pageSize = db; }
            var params = [];
            params.push({ name: 'db', value: db });

            var data = getAllByParams('Dipendente', 'GetAllDipendentiByDB', params);
            return $q.when(data);
        }

        // ******************************
        //  DIPENDENTE CON RUOLO
        function dipendenteConRuolo_getAll(pageSize, page, stato, ricerca, aziendaPartnerId, ruoloId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }
            if (typeof (ruoloId) == 'undefined') { ruoloId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });
            params.push({ name: 'ruoloId', value: ruoloId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('DipendenteConRuolo', 'GetAll', params);
            return $q.when(data);
        }

        function dipendenteConRuolo_countAll(stato, ricerca, aziendaPartnerId, ruoloId) {
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }
            if (typeof (ruoloId) == 'undefined') { ruoloId = 0; }

            var params = [];
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });
            params.push({ name: 'ruoloId', value: ruoloId });

            var data = getAllByParams('DipendenteConRuolo', 'CountAll', params);
            return $q.when(data);
        }

        // ******************************
        //Dipendente Sezione
        function dipendenteSezione_getAll(sezioneId, dipendenteId) {
            if (typeof (sezioneId) == 'undefined') { sezioneId = 0; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }

            var params = [];
            params.push({ name: 'sezioneId', value: sezioneId });
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('DipendenteSezione', 'GetAll', params);
            return $q.when(data);
        }

        function dipendenteSezione_add(sezioneId, dipendenteId) {
            if (typeof (sezioneId) == 'undefined') { sezioneId = 0; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }

            var params = [];
            params.push({ name: 'sezioneId', value: sezioneId });
            params.push({ name: 'dipendenteId', value: dipendenteId });


            var objName = 'DipendenteSezione';
            var actionName = 'AddDipendenteSezione';
            var url = urlAPI + '/' + objName + '/' + actionName;

            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;

            }

            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });

        }

        function dipendenteSezione_addList(dipendenteId, sezioni) {
            var objName = 'DipendenteSezione';
            var method = 'AddList';

            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (sezioni) == 'undefined') { sezioni = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                dipendenteId: dipendenteId,
                sezioni: sezioni
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function dipendenteSezione_delete(item) {
            var data = deleteObj('DipendenteSezione', item);
            return $q.when(data);
        }

        // ******************************
        //  DETTAGLIO DIPENDENTE
        function dettaglioDipendente_getAllList(stato) {
            if (typeof (stato) == 'undefined') { stato = 0; }

            var data = getAllByParam('DettaglioDipendente', 'GetAllList', 'stato', stato);
            return $q.when(data);
        }

        function dettaglioDipendente_getAll(pageSize, page, stato, statoCV, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (statoCV) == 'undefined') { statoCV = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'statoCV', value: statoCV });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('DettaglioDipendente', 'GetAll', params);
            return $q.when(data);
        }

        function dettaglioDipendente_countAll(stato, statoCV, ricerca) {
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (statoCV) == 'undefined') { statoCV = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'statoCV', value: statoCV });
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('DettaglioDipendente', 'CountAll', params);
            return $q.when(data);
        }

        function dettaglioDipendente_get(id) {
            var data = getById('DettaglioDipendente', id);
            return $q.when(data);
        }

        // ******************************
        // ISTRUZIONE
        function istruzione_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('Istruzione', 'GetAll', params);
            return $q.when(data);
        }

        function istruzione_add(item) {
            var data = addObj('Istruzione', item);
            return $q.when(data);
        }

        function istruzione_addList(istruzioni) {
            var objName = 'Istruzione';
            var method = 'AddList';

            if (typeof (istruzioni) == 'undefined') { istruzioni = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                istruzioni: istruzioni
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function istruzione_update(item) {
            var data = updateObj('Istruzione', item);
            return $q.when(data);
        }

        function istruzione_changeSequence(orderList) {
            var objName = 'Istruzione';
            if (typeof (orderList) == 'undefined') { orderList = []; }

            var obj = {
                orderList: orderList
            };

            var url = urlAPI + '/' + objName + '/ChangeSequence';
            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ChangeSequence for %s: %s', objName, message);
                    return message.status;
                });
        }

        function istruzione_delete(id) {
            var data = deleteObj('Istruzione', id);
            return $q.when(data);
        }

        function istruzione_get(id) {
            var data = getById('Istruzione', id);
            return $q.when(data);
        }

        // ******************************
        // FORMAZIONE
        function formazione_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('Formazione', 'GetAll', params);
            return $q.when(data);
        }

        function formazione_add(item) {
            var data = addObj('Formazione', item);
            return $q.when(data);
        }

        function formazione_update(item) {
            var data = updateObj('Formazione', item);
            return $q.when(data);
        }

        function formazione_changeSequence(orderList) {
            var objName = 'Formazione';
            if (typeof (orderList) == 'undefined') { orderList = []; }

            var obj = {
                orderList: orderList
            };

            var url = urlAPI + '/' + objName + '/ChangeSequence';
            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ChangeSequence for %s: %s', objName, message);
                    return message.status;
                });
        }

        function formazione_delete(id) {
            var data = deleteObj('Formazione', id);
            return $q.when(data);
        }

        function formazione_get(id) {
            var data = getById('Formazione', id);
            return $q.when(data);
        }

        // ******************************
        // FASE CURRICULUM
        function faseCurriculum_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('FaseCurriculum', 'GetAll', params);
            return $q.when(data);
        }

        function faseCurriculum_get(dipendenteId, fase) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }
            if (typeof (fase) == 'undefined') { fase = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'fase', value: fase });

            var data = getAllByParams('FaseCurriculum', 'Get', params);
            return $q.when(data);
        }

        // ******************************
        // SOFTWARE
        function software_getAll(dipendenteId, generico) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }
            if (typeof (generico) == 'undefined') { generico = 1 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'generico', value: generico });

            var data = getAllByParams('Software', 'GetAll', params);
            return $q.when(data);
        }

        function software_add(item) {
            var data = addObj('Software', item);
            return $q.when(data);
        }

        function software_addList(dipendenteId, generico, software) {
            var objName = 'Software';
            var method = 'AddList';

            if (typeof (software) == 'undefined') { software = []; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = []; }
            if (typeof (generico) == 'undefined') { generico = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                dipendenteId: dipendenteId,
                generico: generico,
                software: software
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function software_update(item) {
            var data = updateObj('Software', item);
            return $q.when(data);
        }

        function software_delete(id) {
            var data = deleteObj('Software', id);
            return $q.when(data);
        }

        function software_get(id) {
            var data = getById('Software', id);
            return $q.when(data);
        }

        // ******************************
        // COMPETENZA DIGITALE
        function competenzaDigitale_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('CompetenzaDigitale', 'GetAll', params);
            return $q.when(data);
        }

        function competenzaDigitale_add(item) {
            var data = addObj('CompetenzaDigitale', item);
            return $q.when(data);
        }

        function competenzaDigitale_update(item) {
            var data = updateObj('CompetenzaDigitale', item);
            return $q.when(data);
        }

        function competenzaDigitale_delete(id) {
            var data = deleteObj('CompetenzaDigitale', id);
            return $q.when(data);
        }

        function competenzaDigitale_get(id) {
            var data = getById('CompetenzaDigitale', id);
            return $q.when(data);
        }

        // ******************************
        // COMPETENZA TECNICA
        function competenzaTecnica_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('CompetenzaTecnica', 'GetAll', params);
            return $q.when(data);
        }

        function competenzaTecnica_add(item) {
            var data = addObj('CompetenzaTecnica', item);
            return $q.when(data);
        }

        function competenzaTecnica_update(item) {
            var data = updateObj('CompetenzaTecnica', item);
            return $q.when(data);
        }

        function competenzaTecnica_delete(id) {
            var data = deleteObj('CompetenzaTecnica', id);
            return $q.when(data);
        }

        function competenzaTecnica_get(id) {
            var data = getById('CompetenzaTecnica', id);
            return $q.when(data);
        }

        // ******************************
        // DETTAGLIO PROGETTO
        function dettaglioProgetto_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('DettaglioProgetto', 'GetAll', params);
            return $q.when(data);
        }

        function dettaglioProgetto_add(item) {
            var data = addObj('DettaglioProgetto', item);
            return $q.when(data);
        }

        function dettaglioProgetto_update(item) {
            var data = updateObj('DettaglioProgetto', item);
            return $q.when(data);
        }

        function dettaglioProgetto_changeSequence(orderList) {
            var objName = 'DettaglioProgetto';
            if (typeof (orderList) == 'undefined') { orderList = []; }

            var obj = {
                orderList: orderList
            };

            var url = urlAPI + '/' + objName + '/ChangeSequence';
            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ChangeSequence for %s: %s', objName, message);
                    return message.status;
                });
        }

        function dettaglioProgetto_delete(id) {
            var data = deleteObj('DettaglioProgetto', id);
            return $q.when(data);
        }

        function dettaglioProgetto_get(id) {
            var data = getById('DettaglioProgetto', id);
            return $q.when(data);
        }

        // ******************************
        // ESPERIENZA LAVORATIVA
        function esperienzaLavorativa_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('EsperienzaLavorativa', 'GetAll', params);
            return $q.when(data);
        }

        function esperienzaLavorativa_add(item) {
            var data = addObj('EsperienzaLavorativa', item);
            return $q.when(data);
        }

        function esperienzaLavorativa_update(item) {
            var data = updateObj('EsperienzaLavorativa', item);
            return $q.when(data);
        }

        function esperienzaLavorativa_changeSequence(orderList) {
            var objName = 'EsperienzaLavorativa';
            if (typeof (orderList) == 'undefined') { orderList = []; }

            var obj = {
                orderList: orderList
            };

            var url = urlAPI + '/' + objName + '/ChangeSequence';
            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ChangeSequence for %s: %s', objName, message);
                    return message.status;
                });
        }

        function esperienzaLavorativa_delete(id) {
            var data = deleteObj('EsperienzaLavorativa', id);
            return $q.when(data);
        }

        function esperienzaLavorativa_get(id) {
            var data = getById('EsperienzaLavorativa', id);
            return $q.when(data);
        }

        // ******************************
        // LINGUA
        function lingua_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('Lingua', 'GetAll', params);
            return $q.when(data);
        }

        function lingua_add(item) {
            var data = addObj('Lingua', item);
            return $q.when(data);
        }

        function lingua_update(item) {
            var data = updateObj('Lingua', item);
            return $q.when(data);
        }

        function lingua_delete(id) {
            var data = deleteObj('Lingua', id);
            return $q.when(data);
        }

        function lingua_get(id) {
            var data = getById('Lingua', id);
            return $q.when(data);
        }

        // ******************************
        // LINGUAGGIO PROGRAMMAZIONE
        function linguaggioProgrammazione_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('LinguaggioProgrammazione', 'GetAll', params);
            return $q.when(data);
        }

        function linguaggioProgrammazione_add(item) {
            var data = addObj('LinguaggioProgrammazione', item);
            return $q.when(data);
        }

        function linguaggioProgrammazione_addList(dipendenteId, linguaggi) {
            var objName = 'LinguaggioProgrammazione';
            var method = 'AddList';

            if (typeof (linguaggi) == 'undefined') { linguaggi = []; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                dipendenteId: dipendenteId,
                linguaggi: linguaggi
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function linguaggioProgrammazione_update(item) {
            var data = updateObj('LinguaggioProgrammazione', item);
            return $q.when(data);
        }

        function linguaggioProgrammazione_delete(id) {
            var data = deleteObj('LinguaggioProgrammazione', id);
            return $q.when(data);
        }

        function linguaggioProgrammazione_get(id) {
            var data = getById('LinguaggioProgrammazione', id);
            return $q.when(data);
        }

        // ******************************
        // NORMA
        function norma_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('Norma', 'GetAll', params);
            return $q.when(data);
        }

        function norma_add(item) {
            var data = addObj('Norma', item);
            return $q.when(data);
        }

        function norma_addList(dipendenteId, norme) {
            var objName = 'Norma';
            var method = 'AddList';

            if (typeof (norme) == 'undefined') { norme = []; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                DipendenteId: dipendenteId,
                norme: norme
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function norma_update(item) {
            var data = updateObj('Norma', item);
            return $q.when(data);
        }

        function norma_delete(id) {
            var data = deleteObj('Norma', id);
            return $q.when(data);
        }

        function norma_get(id) {
            var data = getById('Norma', id);
            return $q.when(data);
        }

        // ******************************
        // STANDARD
        function standard_getAll(dipendenteId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0 }

            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('Standard', 'GetAll', params);
            return $q.when(data);
        }

        function standard_add(item) {
            var data = addObj('Standard', item);
            return $q.when(data);
        }

        function standard_addList(dipendenteId, standard) {
            var objName = 'Standard';
            var method = 'AddList';

            if (typeof (standard) == 'undefined') { standard = []; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                dipendenteId: dipendenteId,
                standard: standard
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function standard_update(item) {
            var data = updateObj('Standard', item);
            return $q.when(data);
        }

        function standard_delete(id) {
            var data = deleteObj('Standard', id);
            return $q.when(data);
        }

        function standard_get(id) {
            var data = getById('Standard', id);
            return $q.when(data);
        }

        // ******************************
        //  AREA TECNICA
        function areaTecnica_getAllList() {
            var data = getAllNoParam('AreaTecnica', 'GetAllList');
            return $q.when(data);
        }

        function areaTecnica_get(id) {
            var data = getById('AreaTecnica', id);
            return $q.when(data);
        }

        // ******************************
        //  TIPO ATTIVITA
        function tipoAttivita_getAllList() {
            var data = getAllNoParam('tipoAttivita', 'GetAllList');
            return $q.when(data);
        }

        function tipoAttivita_getAllByAreaTecnicaId(areaTecnicaId) {
            var data = getAllByParam('tipoAttivita', 'GetAllByAreaTecnicaId', 'areaTecnicaId', areaTecnicaId);
            return $q.when(data);
        }

        function tipoAttivita_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tipoAttivita', 'GetAll', params);
            return $q.when(data);
        }

        function tipoAttivita_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('tipoAttivita', 'CountAll', params);
            return $q.when(data);
        }

        function tipoAttivita_add(classeObj) {
            var data = addObj('tipoAttivita', classeObj);
            return $q.when(data);
        }

        function tipoAttivita_delete(id) {
            var data = deleteObj('tipoAttivita', id);
            return $q.when(data);
        }

        function tipoAttivita_get(id) {
            var data = getById('tipoAttivita', id);
            return $q.when(data);
        }

        function tipoAttivita_update(item) {
            var data = updateObj('tipoAttivita', item);
            return $q.when(data);
        }

        // ******************************

        // TIPO ASSEGNAZIONE
        function tipoAssegnazione_getAllList() {
            var params = [];

            var data = getAllByParams('TipoAssegnazione', 'GetAllList', params);
            return $q.when(data);
        }

        // ******************************

        // TIPO PRESTAZIONE
        function tipoPrestazione_getAllList() {
            var params = [];

            var data = getAllByParams('TipoPrestazione', 'GetAllList', params);
            return $q.when(data);
        }

        // ******************************
        //  TIPO LINGUAGGIO
        function tipoLinguaggio_getAllList() {
            var data = getAllNoParam('tipoLinguaggio', 'GetAllList');
            return $q.when(data);
        }

        function tipoLinguaggio_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tipoLinguaggio', 'GetAll', params);
            return $q.when(data);
        }

        function tipoLinguaggio_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('tipoLinguaggio', 'CountAll', params);
            return $q.when(data);
        }

        function tipoLinguaggio_add(classeObj) {
            var data = addObj('tipoLinguaggio', classeObj);
            return $q.when(data);
        }

        function tipoLinguaggio_delete(id) {
            var data = deleteObj('tipoLinguaggio', id);
            return $q.when(data);
        }

        function tipoLinguaggio_get(id) {
            var data = getById('tipoLinguaggio', id);
            return $q.when(data);
        }

        function tipoLinguaggio_update(item) {
            var data = updateObj('tipoLinguaggio', item);
            return $q.when(data);
        }

        // ******************************
        //  TIPO MANSIONE
        function tipoMansione_getAllList() {
            var data = getAllNoParam('tipoMansione', 'GetAllList');
            return $q.when(data);
        }

        function tipoMansione_getAllByAreaTecnicaId(areaTecnicaId) {
            var data = getAllByParam('tipoMansione', 'GetAllByAreaTecnicaId', 'areaTecnicaId', areaTecnicaId);
            return $q.when(data);
        }

        function tipoMansione_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tipoMansione', 'GetAll', params);
            return $q.when(data);
        }

        function tipoMansione_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('tipoMansione', 'CountAll', params);
            return $q.when(data);
        }

        function tipoMansione_add(classeObj) {
            var data = addObj('tipoMansione', classeObj);
            return $q.when(data);
        }

        function tipoMansione_delete(id) {
            var data = deleteObj('tipoMansione', id);
            return $q.when(data);
        }

        function tipoMansione_get(id) {
            var data = getById('tipoMansione', id);
            return $q.when(data);
        }

        function tipoMansione_update(item) {
            var data = updateObj('tipoMansione', item);
            return $q.when(data);
        }

        // ******************************
        //  TIPO NORMA
        function tipoNorma_getAllList() {
            var data = getAllNoParam('tipoNorma', 'GetAllList');
            return $q.when(data);
        }

        function tipoNorma_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tipoNorma', 'GetAll', params);
            return $q.when(data);
        }

        function tipoNorma_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('tipoNorma', 'CountAll', params);
            return $q.when(data);
        }

        function tipoNorma_add(classeObj) {
            var data = addObj('tipoNorma', classeObj);
            return $q.when(data);
        }

        function tipoNorma_delete(id) {
            var data = deleteObj('tipoNorma', id);
            return $q.when(data);
        }

        function tipoNorma_get(id) {
            var data = getById('tipoNorma', id);
            return $q.when(data);
        }

        function tipoNorma_update(item) {
            var data = updateObj('tipoNorma', item);
            return $q.when(data);
        }

        // ******************************
        //  TIPO SERVIZIO EN
        function tipoServizioEn_getAll() {
            var data = getAllNoParam('TipoServizioEn', 'GetAll');
            return $q.when(data);
        }

        // ******************************
        //  TIPO SOFTWARE
        function tipoSoftware_getAllList() {
            var data = getAllNoParam('tipoSoftware', 'GetAllList');
            return $q.when(data);
        }

        function tipoSoftware_getAllByAreaTecnicaId(areaTecnicaId) {
            var data = getAllByParam('tipoSoftware', 'GetAllByAreaTecnicaId', 'areaTecnicaId', areaTecnicaId);
            return $q.when(data);
        }

        function tipoSoftware_getAll(pageSize, page, ricerca, order, generici) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }
            if (typeof (generici) == 'undefined') { generici = false; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });
            params.push({ name: 'generici', value: generici });

            var data = getAllByParams('tipoSoftware', 'GetAll', params);
            return $q.when(data);
        }

        function tipoSoftware_countAll(ricerca, generici) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (generici) == 'undefined') { generici = false; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'generici', value: generici });

            var data = getAllByParams('tipoSoftware', 'CountAll', params);
            return $q.when(data);
        }

        function tipoSoftware_add(classeObj) {
            var data = addObj('tipoSoftware', classeObj);
            return $q.when(data);
        }

        function tipoSoftware_delete(id) {
            var data = deleteObj('tipoSoftware', id);
            return $q.when(data);
        }

        function tipoSoftware_get(id) {
            var data = getById('tipoSoftware', id);
            return $q.when(data);
        }

        function tipoSoftware_update(item) {
            var data = updateObj('tipoSoftware', item);
            return $q.when(data);
        }


        // ******************************
        //  TIPO STANDARD
        function tipoStandard_getAllList() {
            var data = getAllNoParam('tipoStandard', 'GetAllList');
            return $q.when(data);
        }

        function tipoStandard_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tipoStandard', 'GetAll', params);
            return $q.when(data);
        }

        function tipoStandard_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('tipoStandard', 'CountAll', params);
            return $q.when(data);
        }

        function tipoStandard_add(classeObj) {
            var data = addObj('tipoStandard', classeObj);
            return $q.when(data);
        }

        function tipoStandard_delete(id) {
            var data = deleteObj('tipoStandard', id);
            return $q.when(data);
        }

        function tipoStandard_get(id) {
            var data = getById('tipoStandard', id);
            return $q.when(data);
        }

        function tipoStandard_update(item) {
            var data = updateObj('tipoStandard', item);
            return $q.when(data);
        }


        // ******************************
        //TEAM
        function team_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Team', 'GetAll', params);
            return $q.when(data);
        }

        function team_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('Team', 'CountAll', params);
            return $q.when(data);
        }

        function team_add(item) {
            var data = addObj('Team', item);
            return $q.when(data);
        }

        function team_update(item) {
            var data = updateObj('Team', item);
            return $q.when(data);
        }

        function team_get(id) {
            var data = getById('Team', id);
            return $q.when(data);
        }

        function team_delete(item) {
            var data = deleteObj('Team', item);
            return $q.when(data);
        }

        // ******************************
        //Attività Controllo
        function attivitaControllo_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('AttivitaControllo', 'CountByFilter', params);
            return $q.when(data);
        }

        function attivitaControllo_getAllByFilter(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = -1; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('AttivitaControllo', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function attivitaControllo_get(id) {
            var data = getById('AttivitaControllo', id);
            return $q.when(data);
        }

        // ******************************
        //DipendentiTeam
        function dipendentiTeam_getAll(teamId, dipendenteId) {
            if (typeof (teamId) == 'undefined') { teamId = 0; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }

            var params = [];
            params.push({ name: 'teamId', value: teamId });
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('DipendentiTeam', 'GetAll', params);
            return $q.when(data);
        }

        function dipendentiTeam_add(teamId, dipendenteId, ruolo) {
            if (typeof (teamId) == 'undefined') { teamId = 0; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (ruolo) == 'undefined') { ruolo = ''; }

            var params = [];
            params.push({ name: 'teamId', value: teamId });
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'ruolo', value: ruolo });


            var objName = 'DipendentiTeam';
            var actionName = 'AddDipendentiTeam';
            var url = urlAPI + '/' + objName + '/' + actionName;

            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;

            }

            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });

        }

        function dipendentiTeam_delete(item) {
            var data = deleteObj('DipendentiTeam', item);
            return $q.when(data);
        }

        // ******************************
        //DipendentiCommessa
        function dipendentiCommessa_getAll(commessaId, dipendenteId) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'dipendenteId', value: dipendenteId });

            var data = getAllByParams('DipendentiCommessa', 'GetAll', params);
            return $q.when(data);
        }

        function dipendentiCommessa_add(commessaId, dipendenteId, ruolo) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (ruolo) == 'undefined') { ruolo = ''; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'ruolo', value: ruolo });


            var objName = 'DipendentiCommessa';
            var actionName = 'AddDipendentiCommessa';
            var url = urlAPI + '/' + objName + '/' + actionName;

            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;

            }

            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });

        }

        function dipendentiCommessa_addList(commessaId, dipendenti, ruolo) {
            var objName = 'DipendentiCommessa';
            var method = 'AddList';

            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (dipendenti) == 'undefined') { dipendenti = []; }
            if (typeof (ruolo) == 'undefined') { ruolo = ''; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                commessaId: commessaId,
                dipendenti: dipendenti,
                ruolo: ruolo
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed ImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function dipendentiCommessa_delete(item) {
            var data = deleteObj('DipendentiCommessa', item);
            return $q.when(data);
        }

        // ******************************
        //COSTI BASE
        function costiBase_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('CostiBase', 'GetAll', params);
            return $q.when(data);
        }

        function costiBase_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('CostiBase', 'CountAll', params);
            return $q.when(data);
        }

        function costiBase_add(item) {
            var data = addObj('CostiBase', item);
            return $q.when(data);
        }

        function costiBase_update(item) {
            var data = updateObj('CostiBase', item);
            return $q.when(data);
        }

        function costiBase_get(id) {
            var data = getById('CostiBase', id);
            return $q.when(data);
        }

        function costiBase_delete(item) {
            var data = deleteObj('CostiBase', item);
            return $q.when(data);
        }

        function costiBase_getDefault() {
            return $http.get(urlAPI + '/CostiBase/GetDefault')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed costiBase_getDefault: %s', message);
                    return message.status;
                });
		}

        // ******************************
        //  RICHIESTAFERIE
        function richiestaFerie_getAllList() {

            var data = getAllNoParam('RichiestaFerie', 'GetAllList');
            return $q.when(data);
        }

        function richiestaFerie_getAllByFilter(pageSize, page, dtInizio, dtFine, stato, order) {

            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (dtInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dtFine) == 'undefined') { dataFine = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'dtInizio', value: dtInizio });
            params.push({ name: 'dtFine', value: dtFine });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'order', value: order });


            var data = getAllByParams('RichiestaFerie', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function richiestaFerie_countAll(dtInizio, dtFine, stato) {
            if (typeof (dtInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dtFine) == 'undefined') { dataFine = ''; }
            if (typeof (stato) == 'undefined') { stato = -1; }

            var params = [];
            params.push({ name: 'dtInizio', value: dtInizio });
            params.push({ name: 'dtFine', value: dtFine });
            params.push({ name: 'stato', value: stato });

            var data = getAllByParams('RichiestaFerie', 'CountByFilter', params);
            return $q.when(data);
        }

        function richiestaFerie_getValidFerie(dtInizio, dtFine) {
            if (typeof (dtInizio) == 'undefined') { dtInizio = ''; }
            if (typeof (dtFine) == 'undefined') { dtFine = ''; }

            var params = [];
            params.push({ name: 'dtInizio', value: dtInizio });
            params.push({ name: 'dtFine', value: dtFine });

            var data = getAllByParams('RichiestaFerie', 'GetValidFerie', params);
            return $q.when(data);
        }

        function richiestaFerie_getReportFerie(dtInizio, dtFine) {
            if (typeof (dtInizio) == 'undefined') { dtInizio = ''; }
            if (typeof (dtFine) == 'undefined') { dtFine = ''; }

            var params = [];
            params.push({ name: 'dtInizio', value: dtInizio });
            params.push({ name: 'dtFine', value: dtFine });

            var data = getAllByParams('RichiestaFerie', 'GetReportFerie', params);
            return $q.when(data);
        }

        function richiestaFerie_get(id) {
            var data = getById('RichiestaFerie', id);
            return $q.when(data);
        }

        function richiestaFerie_add(item) {

            var data = addObj('RichiestaFerie', item);
            return $q.when(data);
        }

        function richiestaFerie_addMultiplo(items) {
            var objName = 'RichiestaFerie';
            var method = 'AddMultiplo';

            return $http.post(urlAPI + '/' + objName + '/' + method, items)
                .then(function (response) {
                    return response;
                })
                .catch(function (message) {
                    console.log('XHR Failed richiestaFerie_addMultiplo: %s', message);
                    return message.status;
                });
        }

        function richiestaFerie_update(item) {
            var data = updateObj('RichiestaFerie', item);
            return $q.when(data);
        }

        function richiestaFerie_inoltra(item) {
            return $http.put(urlAPI + '/RichiestaFerie/Inoltra', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed richiestaFerie_inoltra: %s', message);
                    return message.status;
                });
        }

        function richiestaFerie_delete(id) {
            var data = deleteObj('RichiestaFerie', id);
            return $q.when(data);
        }

        // ******************************
        //  VALIDAZIONERICHIESTAFERIE
        function validazioneRichiestaFerie_getAllValid(pageSize, page, dtInizio, dtFine, stato, ricerca, order) {

            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (dtInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dtFine) == 'undefined') { dataFine = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
			if (typeof (order) == 'undefined') { order = 'id'; }
			if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'dtInizio', value: dtInizio });
            params.push({ name: 'dtFine', value: dtFine });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'order', value: order });
			params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('ValidazioneRichiestaFerie', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function validazioneRichiestaFerie_countValid(dtInizio, dtFine, stato, ricerca) {
            if (typeof (dtInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dtFine) == 'undefined') { dataFine = ''; }
            if (typeof (stato) == 'undefined') { stato = -1; }
			if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'dtInizio', value: dtInizio });
            params.push({ name: 'dtFine', value: dtFine });
            params.push({ name: 'stato', value: stato });
			params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('ValidazioneRichiestaFerie', 'CountByFilter', params);
            return $q.when(data);
        }

        function validazioneRichiestaFerie_accetta(item) {
            return $http.put(urlAPI + '/ValidazioneRichiestaFerie/Accetta', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed Accetta for ValidazioneRichiestaFerie: %s', message);
                    return message.status;
                });
        }

        function validazioneRichiestaFerie_rifiuta(item) {
            return $http.put(urlAPI + '/ValidazioneRichiestaFerie/Rifiuta', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed Rifiuta for ValidazioneRichiestaFerie: %s', message);
                    return message.status;
                });
        }

        // ******************************
        //  PROFILO DIPENDENTI
        function profiloDipendenti_get(id) {
            var data = getById('ProfiloDipendenti', id);
            return $q.when(data);
        }

        //function profiloDipendenti_update(item) {
        //    var data = updateObj('ProfiloDipendenti', item);
        //    return $q.when(data);
        //}


        function profiloDipendenti_getByDipendenteId(dipendenteId, profiloOreId) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (profiloOreId) == 'undefined') { profiloOreId = 0; }

            return $http.get(urlAPI + '/ProfiloDipendenti/Get/?dipendenteId=' + dipendenteId + '&profiloOreId=' + profiloOreId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed profiloDipendenti_getByDipendenteId: %s', message);
                    return message.status;
                });
        }

        function profiloDipendenti_add(item) {
            var data = addObj('ProfiloDipendenti', item);
            return $q.when(data);
        }

        function profiloDipendenti_update(item) {
            var data = updateObj('ProfiloDipendenti', item);
            return $q.when(data);
        }

        function profiloDipendenti_delete(item) {
            var data = deleteObj('ProfiloDipendenti', item);
            return $q.when(data);
        }

        // ******************************
        // GIUSTIFICATIVO
        function giustificativo_getAllList(richiesteFerie) {
            if (typeof (richiesteFerie) == 'undefined')
                var data = getAllNoParam('Giustificativo', 'GetAllList');
            else {
                var params = [];
                params.push({ name: 'richiesteFerie', value: richiesteFerie });
                var data = getAllByParams('Giustificativo', 'GetAllListByParams', params);
            }

            return $q.when(data);
        }

        function giustificativo_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Giustificativo', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function giustificativo_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('Giustificativo', 'CountByFilter', params);
            return $q.when(data);
        }

        function giustificativo_get(id) {
            var data = getById('Giustificativo', id);
            return $q.when(data);
        }


        function giustificativo_add(item) {
            var data = addObj('Giustificativo', item);
            return $q.when(data);
        }

        function giustificativo_update(item) {
            var data = updateObj('Giustificativo', item);
            return $q.when(data);
        }

        function giustificativo_delete(id) {
            var data = deleteObj('Giustificativo', id);
            return $q.when(data);
        }

        // ******************************
        // SETTINGS
        function settings_getAll(pageSize, page, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Settings', 'GetAll', params);
            return $q.when(data);
        }

        function settings_countAll() {
            var data = getAllNoParam('Settings', 'CountAll');
            return $q.when(data);
        }

        function settings_get(id) {
            var data = getById('Settings', id);
            return $q.when(data);
        }


        function settings_add(item) {
            var data = addObj('Settings', item);
            return $q.when(data);
        }

        function settings_update(item) {
            var data = updateObj('Settings', item);
            return $q.when(data);
        }

        function settings_delete(id) {
            var data = deleteObj('Settings', id);
            return $q.when(data);
        }

        // ******************************
        //  PUSH NOTIFICATION
        function pushNotification_add(dipendenteId, message) {
            return $http.post(urlAPI + '/PushNotification/Send?dipendenteId=' + dipendenteId + '&message=' + message)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed pushNotification_add: %s', message);
                    return message.status;
                });
        }

        // ******************************
        // PROFILO ORE
        function profiloOre_get(id) {
            var data = getById('ProfiloOre', id); //profiloOre
            return $q.when(data);
        }

        function profiloOre_getAllList() {
            var data = getAllNoParam('ProfiloOre', 'GetAllList'); //profiloOre
            return $q.when(data);
        }

        function profiloOre_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('ProfiloOre', 'GetAll', params);
            return $q.when(data);
        }

        function profiloOre_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('ProfiloOre', 'CountAll', params);
            return $q.when(data);
        }

        function profiloOre_add(item) {
            var data = addObj('ProfiloOre', item);
            return $q.when(data);
        }

        function profiloOre_update(item) {
            var data = updateObj('ProfiloOre', item);
            return $q.when(data);
        }

        //function profiloOre_get(id) {
        //    var data = getById('ProfiloOre', id);
        //    return $q.when(data);
        //}

        function profiloOre_delete(item) {
            var data = deleteObj('ProfiloOre', item);
            return $q.when(data);
        }




        // ******************************
        // REPORT 

        function report_getPresenze(bPDF, anno, mese, aziendaPartnerId) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Report', 'GetPresenze', params);
            return $q.when(data);
        }

        function report_getTimeSheetMensile(bPDF, dipendenteId, anno, mese) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });

            var data = getAllByParams('Report', 'GetMensile', params);
            return $q.when(data);
        }

        function report_getTimeSheetMensileDipendenti(bPDF, dipendenteId, anno, mese, aziendaPartnerId) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = -1; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Report', 'GetMensileDipendenti', params);
            return $q.when(data);
        }

        function report_getTimeSheet(bPDF, dipendenteId, anno, settimana) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (settimana) == 'undefined') { settimana = 0; }
            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'settimana', value: settimana });

            var data = getAllByParams('Report', 'GetSettimanale', params);
            return $q.when(data);
        }

        function report_getCosti(bPDF, anno, mese, dataInizio, dataFine, aziendaPartnerId) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (dataInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dataFine) == 'undefined') { dataFine = ''; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'dataInizio', value: dataInizio });
            params.push({ name: 'dataFine', value: dataFine });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Report', 'GetReportCosti', params);
            return $q.when(data);
        }

        function report_getCommesse(bPDF, commessa, anno, mese, dataInizio, dataFine, dipendenteId, aziendaPartnerId) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (commessa) == 'undefined') { commessa = ''; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (dataInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dataFine) == 'undefined') { dataFine = ''; }
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'commessa', value: commessa });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'dataInizio', value: dataInizio });
            params.push({ name: 'dataFine', value: dataFine });
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('Report', 'GetReportCommesse', params);
            return $q.when(data);
        }

        function report_getFerie(bPDF, dataInizio, dataFine) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (dataInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dataFine) == 'undefined') { dataFine = ''; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'dataInizio', value: dataInizio });
            params.push({ name: 'dataFine', value: dataFine });

            var data = getAllByParams('Report', 'GetReportFerie', params);
            return $q.when(data);
        }

        function report_Commessa(Id, bPDF) {
            if (typeof (Id) == 'undefined') { Id = 0; }
            if (typeof (bPDF) == 'undefined') { bPDF = true; }

            var params = [];
            params.push({ name: 'Id', value: Id });
            params.push({ name: 'bPDF', value: bPDF });

            var data = getAllByParams('Report', 'GetReportCommessa', params);
            return $q.when(data);
        }

        function report_getVerificaTimeSheet(bPDF, anno, mese) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });

            var data = getAllByParams('Report', 'GetVerificaTimeSheet', params);
            return $q.when(data);
        }

        function report_getTotaliCommSez(bPDF, anno, mese, dataInizio, dataFine) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (dataInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dataFine) == 'undefined') { dataFine = ''; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'dataInizio', value: dataInizio });
            params.push({ name: 'dataFine', value: dataFine });

            var data = getAllByParams('Report', 'GetReportTotaliCommSez', params);
            return $q.when(data);
        }

        function report_getTotaliSezDip(bPDF, anno, mese, dataInizio, dataFine) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (dataInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dataFine) == 'undefined') { dataFine = ''; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'dataInizio', value: dataInizio });
            params.push({ name: 'dataFine', value: dataFine });

            var data = getAllByParams('Report', 'GetReportTotaliSezDip', params);
            return $q.when(data);
        }

        function report_getTotaliSezioni(bPDF, anno, mese, dataInizio, dataFine) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (dataInizio) == 'undefined') { dataInizio = ''; }
            if (typeof (dataFine) == 'undefined') { dataFine = ''; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'dataInizio', value: dataInizio });
            params.push({ name: 'dataFine', value: dataFine });

            var data = getAllByParams('Report', 'GetReportTotaliSezioni', params);
            return $q.when(data);
        }

        function report_getDipendenti(bPDF, anno, azienda) {
            if (typeof (bPDF) == 'undefined') { bPDF = false; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (azienda) == 'undefined') { azienda = ''; }

            var params = [];
            params.push({ name: 'bPDF', value: bPDF });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'azienda', value: azienda });

            var data = getAllByParams('Report', 'GetReportDipendenti', params);
            return $q.when(data);
        }

        // ******************************
        // REPORT ORE
        function reportOre_getAll(pageSize, page, anno, mese, settimana, giorno, commessa, cdc, ricerca, causale, aziendaPartnerId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (settimana) == 'undefined') { settimana = 0; }
            if (typeof (giorno) == 'undefined') { giorno = 0; }
            if (typeof (commessa) == 'undefined') { commessa = -1; }
            if (typeof (cdc) == 'undefined') { cdc = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (causale) == 'undefined') { order = -1; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'settimana', value: settimana });
            params.push({ name: 'giorno', value: giorno });
            params.push({ name: 'commessa', value: commessa });
            params.push({ name: 'cdc', value: cdc });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });
            params.push({ name: 'causale', value: causale });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('ReportOra', 'GetAll', params);
            return $q.when(data);
        }

        function reportOre_countAll(anno, mese, settimana, giorno, commessa, cdc, ricerca, causale, aziendaPartnerId) {
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (settimana) == 'undefined') { settimana = 0; }
            if (typeof (giorno) == 'undefined') { giorno = 0; }
            if (typeof (commessa) == 'undefined') { commessa = -1; }
            if (typeof (cdc) == 'undefined') { cdc = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (causale) == 'undefined') { order = -1; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'settimana', value: settimana });
            params.push({ name: 'giorno', value: giorno });
            params.push({ name: 'commessa', value: commessa });
            params.push({ name: 'cdc', value: cdc });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'causale', value: causale });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('ReportOra', 'CountAll', params);
            return $q.when(data);
        }

        function reportOre_getSum(anno, mese, settimana, giorno, commessa, cdc, ricerca, causale, aziendaPartnerId) {
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (settimana) == 'undefined') { settimana = 0; }
            if (typeof (giorno) == 'undefined') { giorno = 0; }
            if (typeof (commessa) == 'undefined') { commessa = -1; }
            if (typeof (cdc) == 'undefined') { cdc = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (causale) == 'undefined') { order = -1; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'settimana', value: settimana });
            params.push({ name: 'giorno', value: giorno });
            params.push({ name: 'commessa', value: commessa });
            params.push({ name: 'cdc', value: cdc });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'causale', value: causale });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('ReportOra', 'GetSum', params);
            return $q.when(data);
        }

        function reportOre_getTotale(anno, mese, settimana, giorno, commessa, cdc, ricerca, causale, aziendaPartnerId) {
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            if (typeof (settimana) == 'undefined') { settimana = 0; }
            if (typeof (giorno) == 'undefined') { giorno = 0; }
            if (typeof (commessa) == 'undefined') { commessa = -1; }
            if (typeof (cdc) == 'undefined') { cdc = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (causale) == 'undefined') { order = -1; }
            if (typeof (aziendaPartnerId) == 'undefined') { aziendaPartnerId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });
            params.push({ name: 'settimana', value: settimana });
            params.push({ name: 'giorno', value: giorno });
            params.push({ name: 'commessa', value: commessa });
            params.push({ name: 'cdc', value: cdc });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'causale', value: causale });
            params.push({ name: 'aziendaPartnerId', value: aziendaPartnerId });

            var data = getAllByParams('ReportOra', 'GetTotale', params);
            return $q.when(data);
        }

        // ******************************
        //  SEZIONE
        function sezione_getAllList() {
            var data = getAllNoParam('Sezione', 'GetAllList');
            return $q.when(data);
        }

        function sezione_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Sezione', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function sezione_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('Sezione', 'CountByFilter', params);
            return $q.when(data);
        }

        function sezione_getAllListForTimeSheet(commessaId) {
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }

            var params = [];
            params.push({ name: 'commessaId', value: commessaId });

            var data = getAllByParams('Sezione', 'GetAllListForTimeSheet', params);
            return $q.when(data);
        }

        function sezione_getAllForTimeSheet(pageSize, page, ricerca, commessaId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (commessaId) == 'undefined') { commessaId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'commessaId', value: commessaId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Sezione', 'GetAllForTimeSheet', params);
            return $q.when(data);
        }

        function sezione_get(id) {
            var data = getById('Sezione', id);
            return $q.when(data);
        }

        function sezione_add(item) {
            var data = addObj('Sezione', item);
            return $q.when(data);
        }

        function sezione_update(item) {
            var data = updateObj('Sezione', item);
            return $q.when(data);
        }

        function sezione_delete(id) {
            var data = deleteObj('Sezione', id);
            return $q.when(data);
        }

        // ******************************
        // TIMESHEET
        function timeSheet_getAll(dipendenteId) {
            var data = getAllByParam('TimeSheet', 'GetAllByFilter', 'dipendenteId', dipendenteId);
            return $q.when(data);
        }

        function timeSheet_getById(id) {
            var data = getById('TimeSheet', id);
            return $q.when(data);
        }

        function timeSheet_get(dipendenteId, anno, settimana) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (settimana) == 'undefined') { settimana = 0; }
            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'settimana', value: settimana });

            var data = getAllByParams('TimeSheet', 'Get', params);
            return $q.when(data);
        }

        function timeSheet_getMensile(dipendenteId, anno, mese) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });

            var data = getAllByParams('TimeSheet', 'GetMensile', params);
            return $q.when(data);
        }

        function timeSheet_save(item) {
            return $http.post(urlAPI + '/TimeSheet/save', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed timeSheet_save %s:', message);
                    return message.status;
                });
        }

        function timeSheet_delete(id) {
            var data = deleteObj('TimeSheet', id);
            return $q.when(data);
        }

        function timeSheet_getRiepilogo(dipendenteId, anno, mese) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (mese) == 'undefined') { mese = 0; }
            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'mese', value: mese });

            var data = getAllByParams('TimeSheet', 'GetRiepilogoDipendenti', params);
            return $q.when(data);
        }

        function timeSheet_getRiepilogoSettimanale(dipendenteId, dtInizio, dtFine) {
            if (typeof (dipendenteId) == 'undefined') { dipendenteId = 0; }
            if (typeof (dtInizio) == 'undefined') { dtInizio = null; }
            if (typeof (dtFine) == 'undefined') { dtFine = null; }
            var params = [];
            params.push({ name: 'dipendenteId', value: dipendenteId });
            params.push({ name: 'dtInizio', value: dtInizio });
            params.push({ name: 'dtFine', value: dtFine });

            var data = getAllByParams('TimeSheet', 'GetRiepilogoDipendentiSettimanale', params);
            return $q.when(data);
        }

        function timeSheet_getWeek(data) {
            if (typeof (data) == 'undefined') { data = ''; }
            var data = getAllByParam('TimeSheet', 'GetWeek', 'Data', data);
            return $q.when(data);
        }

        function timeSheet_getWeekByDate(data) {
            if (typeof (data) == 'undefined') { data = ''; }
            var data = getAllByParam('TimeSheet', 'GetWeekByDate', 'data', data);
            return $q.when(data);
        }

        function timeSheet_getDate() {
            var data = getAllNoParam('TimeSheet', 'GetDate');
            return $q.when(data);
        }

        function timeSheet_getDatesOfWeek(anno, settimana) {
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (settimana) == 'undefined') { settimana = 0; }
            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'settimana', value: settimana });

            var data = getAllByParams('TimeSheet', 'GetDatesOfWeek', params);
            return $q.when(data);
        }

        // ******************************
        //  VALIDAZIONE TIMESHEET
        function validazioneTimeSheet_getAll(pageSize, page, convalidato, stato, sezioneId, dataI, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 0; }
            if (typeof (convalidato) == 'undefined') { stato = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (sezioneId) == 'undefined') { sezioneId = 0; }
            if (typeof (dataI) == 'undefined') { dataI = ''; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'convalidato', value: convalidato });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'sezioneId', value: sezioneId });
            params.push({ name: 'data', value: dataI });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('ValidazioneTimeSheet', 'GetAll', params);
            return $q.when(data);
        }

        function validazioneTimeSheet_countAll(convalidato, stato, sezioneId, dataI, ricerca) {
            if (typeof (convalidato) == 'undefined') { stato = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (sezioneId) == 'undefined') { sezioneId = 0; }
            if (typeof (dataI) == 'undefined') { dataI = ''; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'convalidato', value: convalidato });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'sezioneId', value: sezioneId });
            params.push({ name: 'data', value: dataI });
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('ValidazioneTimeSheet', 'CountAll', params);
            return $q.when(data);
        }

        function validazioneTimeSheet_convalida(id_rik, valore) {
            if (typeof (id_rik) == 'undefined') { id_rik = 0; }
            if (typeof (valore) == 'undefined') { valore = 0; }

            return $http.put(urlAPI + '/ValidazioneTimeSheet/Convalida?id_rik=' + id_rik + '&valore=' + valore)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed validazioneTimeSheet_convalida: %s', message);
                    return message.status;
                });
        }

        function validazioneTimeSheet_notificaTutti(gruppoId, data, ricerca, message) {
            if (typeof (gruppoId) == 'undefined') { gruppoId = 0; }
            if (typeof (data) == 'undefined') { data = ''; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (message) == 'undefined') { message = ''; }

            var params = [];
            params.push({ name: 'gruppoId', value: gruppoId });
            params.push({ name: 'data', value: data });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'message', value: message });

            var data = getAllByParams('ValidazioneTimeSheet', 'NotificaTutti', params);
            return $q.when(data);
        }

        // ******************************
        // AUTHORIZATION
        function authorization_get() {

            var objName = 'user';
            var actionName = 'GetAuthorization';
            var url = urlAPI + '/' + objName + '/' + actionName;

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed authorization_get for %s: %s', objName, message);
                    return message.status;
                });
        }

        function authorization_getAllByFilter(pageSize, page, userId, roleId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (userId) == 'undefined') { userId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'userId', value: userId });
            params.push({ name: 'roleId', value: roleId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('Authorization', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function authorization_countByFilter(userId, roleId) {
            if (typeof (userId) == 'undefined') { userId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'userId', value: userId });
            params.push({ name: 'roleId', value: roleId });

            var data = getAllByParams('Authorization', 'CountByFilter', params);
            return $q.when(data);
        }

        function authorization_add(item) {
            var data = addObj('Authorization', item);
            return $q.when(data);
        }

        function authorization_update(item) {
            var data = updateObj('Authorization', item);
            return $q.when(data);
        }

        function authorization_delete(item) {
            var data = deleteObj('Authorization', item);
            return $q.when(data);
        }

        // ******************************
        //  ISTAT
        function istat_comune_getAllList(idprov) {
            var data = getAllByParam('comune', 'GetAllByIdProv', 'id', idprov);
            return $q.when(data);
        }

        function istat_comune_get(id) {
            var data = getById('comune', id);
            return $q.when(data);
        }

        // ******************************
        //  USER
        function user_getAll(pageSize, page, bAttivo, username, email, ruolo, order) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (username) == 'undefined') { username = ''; }
            if (typeof (email) == 'undefined') { email = ''; }
            if (typeof (ruolo) == 'undefined') { ruolo = ''; }
            if (typeof (order) == 'undefined') { order = 'alfabetico'; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'username', value: username });
            params.push({ name: 'email', value: email });
            params.push({ name: 'ruolo', value: ruolo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('user', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function user_getAllList() {
            var objName = 'user';
            var actionName = 'GetAllList';
            var url = urlAPI + '/' + objName + '/' + actionName;

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function user_countAll(bAttivo, username, email, ruolo) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (username) == 'undefined') { username = ''; }
            if (typeof (email) == 'undefined') { email = 0; }
            if (typeof (ruolo) == 'undefined') { ruolo = ''; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'username', value: username });
            params.push({ name: 'email', value: email });
            params.push({ name: 'ruolo', value: ruolo });

            var data = getAllByParams('user', 'CountByFilter', params);
            return $q.when(data);
        }

        //metodo per il recupero della lista di Username per allievi e docenti
        function user_getAllUsernames() {
            var data = getAllNoParam('user', 'GetAllUsernames');
            return $q.when(data);
        }

        function user_get(id) {
            var data = getById('user', id);
            return $q.when(data);
        }

        function user_getByUsername(username) {
            var data = getAllByParam('user', 'GetByUsername', 'username', username);
            return $q.when(data);
        }

        function user_getByDipendenteId(id) {
            var data = getAllByParam('user', 'GetByDipendenteId', 'id', id);
            return $q.when(data);
        }

        function user_add(item) {
            var data = addObj('user', item);
            return $q.when(data);
        }

        function user_update(item) {
            var data = updateObj('user', item);
            return $q.when(data);
        }

        function user_activate(id) {
            var url = urlAPI + '/user/activate?id=' + id;
            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed activate for user: %s', message);
                    return message.status;
                });
        }

        function user_deactivate(id) {
            var url = urlAPI + '/user/deactivate?id=' + id;
            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed deactivate for user: %s', message);
                    return message.status;
                });
        }

        function user_resetPassword(email) {
            var url = urlAPI + '/user/resetpassword?email=' + email;
            return $http.post(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed Reset Password for user: %s', message);
                    return message.status;
                });
        }

        function user_invioCredenziali(email) {
            var url = urlAPI + '/user/invioCredenziali?email=' + email;
            return $http.post(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed Reset Password for user: %s', message);
                    return message.status;
                });
        }

        function user_delete(id) {
            var data = deleteObj('user', id);
            return $q.when(data);
        }

        function user_suggestUserame(nome, cognome) {
            if (typeof (nome) == 'undefined') { nome = ""; }
            if (typeof (cognome) == 'undefined') { cognome = "" }
            var params = [];
            params.push({ name: 'nome', value: nome });
            params.push({ name: 'cognome', value: cognome });

            var data = getAllByParams('user', 'SuggestUsername', params);
            return $q.when(data);
        }

        function user_suggestPassword(nome) {
            if (typeof (nome) == 'undefined') { nome = ""; }
            var params = [];
            params.push({ name: 'nome', value: nome });

            var data = getAllByParams('user', 'SuggestPassword', params);
            return $q.when(data);
        }

        // ******************************
        //  SUPER_USER
        function super_user_getAll(pageSize, page, ricerca, bAttivato, aziendaId, ruoloId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }

            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (bAttivato) == 'undefined') { bAttivato = -1; }
            if (typeof (aziendaId) == 'undefined') { aziendaId = 0; }
            if (typeof (ruoloId) == 'undefined') { ruoloId = 0; }

            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });

            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'bAttivato', value: bAttivato });
            params.push({ name: 'aziendaId', value: aziendaId });
            params.push({ name: 'ruoloId', value: ruoloId });

            params.push({ name: 'order', value: order });

            var data = getAllByParams('user', 'Super_GetUsers', params);
            return $q.when(data);
        }

        function super_user_countAll(ricerca, bAttivato, aziendaId, ruoloId) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (bAttivato) == 'undefined') { bAttivato = -1; }
            if (typeof (aziendaId) == 'undefined') { aziendaId = 0; }
            if (typeof (ruoloId) == 'undefined') { ruoloId = 0; }

            var params = [];

            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'bAttivato', value: bAttivato });
            params.push({ name: 'aziendaId', value: aziendaId });
            params.push({ name: 'ruoloId', value: ruoloId });

            var data = getAllByParams('user', 'Super_CountUsers', params);
            return $q.when(data);
        }

        // ******************************
        //  ROLE   
        function role_getAll() {
            var objName = 'user';
            var actionName = 'GetAllRoles';
            var url = urlAPI + '/' + objName + '/' + actionName;

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll for %s: %s', objName, message);
                    return message.status;
                });
        }

        function role_getAllList() {
            var objName = 'user';
            var actionName = 'GetAllListRoles';
            var url = urlAPI + '/' + objName + '/' + actionName;

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllListRoles for %s: %s', objName, message);
                    return message.status;
                });
        }

        function role_get(id) {
            var objName = 'user';
            var actionName = 'GetRole';
            var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll for %s: %s', objName, message);
                    return message.status;
                });
        }

        // ******************************
        //  USER ROLE  
        function userRole_getAll(id) {
            var objName = 'user';
            var actionName = 'GetUserRoles';
            var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll for %s: %s', objName, message);
                    return message.status;
                });
        }

        function userRole_add(risorsaId, roleId) {
            if (typeof (risorsaId) == 'undefined') { risorsaId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'risorsaId', value: risorsaId });
            params.push({ name: 'roleId', value: roleId });

            var objName = 'user';
            var actionName = 'AddUserRole';
            var url = urlAPI + '/' + objName + '/' + actionName;
            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;

            }
            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });

        }

        function userRole_delete(risorsaId, roleId) {
            if (typeof (risorsaId) == 'undefined') { risorsaId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'risorsaId', value: risorsaId });
            params.push({ name: 'roleId', value: roleId });

            var objName = 'user';
            var actionName = 'DeleteUserRole';
            var url = urlAPI + '/' + objName + '/' + actionName;
            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;
            }

            return $http.delete(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed deleteObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        //SYSTEM
        function getWhoAmI() {
            return $http.get(urlAPI + '/system/whoami')
                .then(getWhoAmIComplete)
                .catch(function (message) {
                    console.log('XHR Failed for whoami: %s', message);
                });

            function getWhoAmIComplete(response) {
                return response.data;
            }
        }

        function getYearsList() {
            var listAnno = [];
            for (var i = 0; i <= 19; i++) {
                var item = {};
                item.value = 2016 - i;
                item.text = (2016 - i).toString();
                listAnno.push(item);
            }
            for (var i = 0; i <= 19; i++) {
                var item = {};
                item.value = 2017 + i;
                item.text = (2017 + i).toString();
                listAnno.push(item);
            }
            return _.sortBy(listAnno, function (o) { return o.value; });
        }

        function logGetAll() {
            var data = getAllNoParam('System', 'Log_GetAll');
            return $q.when(data);
        }

        function logDelete(id) {
            var objName = 'System';
            return $http.delete(urlAPI + '/' + objName + '/Log_Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed logDelete for %s: %s', objName, message);
                    return message.status;
                });
        }

        function pushGetAll() {
            var data = getAllNoParam('System', 'Push_GetAll');
            return $q.when(data);
        }

        function pushDelete(id) {
            var objName = 'System';
            return $http.delete(urlAPI + '/' + objName + '/Push_Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed pushDelete for %s: %s', objName, message);
                    return message.status;
                });
        }

        function festivita_getAll() {
            var data = getAllNoParam('System', 'Festivita_GetAll');
            return $q.when(data);
        }

        // ******************************
        //  ATTACH - NUOVI METODI
        function attach_getAllList(tSourceCode, tSourceId, sourceId, tAttachId) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }

            var params = [];
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tAttachId', value: tAttachId });

            var data = getAllByParams('attach', 'GetAllList', params);
            return $q.when(data);
        }

        function attach_getAll(pageSize, page, tSourceCode, tSourceId, sourceId, tAttachId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tAttachId', value: tAttachId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('attach', 'GetAllByFilter', params);
            return $q.when(data);
        }


        function attach_countAll(tSourceCode, tSourceId, sourceId, tAttachId) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }

            var params = [];
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tAttachId', value: tAttachId });

            var data = getAllByParams('attach', 'CountByFilter', params);
            return $q.when(data);
        }

        function attach_get(id) {
            var data = getById('attach', id);
            return $q.when(data);
        }

        function attach_add(item) {
            var data = addObj('attach', item);
            return $q.when(data);
        }

        function attach_update(item) {
            var data = updateObj('attach', item);
            return $q.when(data);
        }

        function attach_delete(id) {
            var data = deleteObj('attach', id);
            return $q.when(data);
        }

        function attach_setCompleted(id) {
            var objName = 'attach';

            return $http.put(urlAPI + '/' + objName + '/SetCompleted/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
                    return message.status;
                });
        }

        function attach_unsetCompleted(id) {
            var objName = 'attach';

            return $http.put(urlAPI + '/' + objName + '/UnsetCompleted/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
                    return message.status;
                });
        }

        function attach_download(tirocinioId, tirocinanteId, classeId, misura) {
            if (typeof (tirocinioId) == 'undefined') { tirocinioId = 0; }
            if (typeof (tirocinanteId) == 'undefined') { tirocinanteId = 0; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (misura) == 'undefined') { misura = 0; }

            var params = [];
            params.push({ name: 'tirocinioId', value: tirocinioId });
            params.push({ name: 'tirocinanteId', value: tirocinanteId });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'misura', value: misura });

            var objName = 'attach';
            var actionName = 'Download';
            var url = urlAPI + '/' + objName + '/' + actionName;
            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;
            }

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed Download for %s: %s', objName, message);
                    return message.status;
                });
        }

        function attach_extract(id) {
            return $http.get(urlAPI + '/Attach/Extract/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed getById for Extract: %s', message);
                    return message.status;
                });
        }

        function upload_getURL() {
            var controller = 'Attach';
            var action = 'Upload';

            return urlAPI + '/' + controller + '/' + action + '/';
        }


        // ******************************
        //  TATTACH - NUOVI METODI
        function tAttach_getAllList(tSourceCode, tSourceId, sourceId, onlyMissing, tAttachId) {
            /*
        onlyMissing:
          1: solo mancanti
          0: tutte
          -1: sono presenti
      */
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (onlyMissing) == 'undefined') { onlyMissing = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'onlyMissing', value: onlyMissing });
            params.push({ name: 'tAttachId', value: tAttachId });

            var data = getAllByParams('tAttach', 'GetAllList', params);
            return $q.when(data);
        }

        function tAttach_getAllModal(tSourceCode, tSourceId, sourceId, onlyMissing, order) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (onlyMissing) == 'undefined') { onlyMissing = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'onlyMissing', value: onlyMissing });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tAttach', 'GetAllByFilter', params);
            return $q.when(data);
        }


        function tAttach_getAll(pageSize, page, tSourceCode, tSourceId, testuale, roleId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = 0; }
            if (typeof (page) == 'undefined') { page = 0; }
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (testuale) == 'undefined') { testuale = ''; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'roleId', value: roleId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tAttach', 'GetAllWithoutVisibility', params);
            return $q.when(data);
        }

        function tAttach_countAll(tSourceCode, tSourceId, testuale, roleId) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (testuale) == 'undefined') { testuale = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'roleId', value: roleId });

            var data = getAllByParams('tAttach', 'CountWithoutVisibility', params);
            return $q.when(data);
        }


        function tAttach_get(id) {
            var data = getById('tAttach', id);
            return $q.when(data);
        }

        function tAttach_add(item) {
            var data = addObj('tAttach', item);
            return $q.when(data);
        }

        function tAttach_update(item) {
            var data = updateObj('tAttach', item);
            return $q.when(data);
        }

        function tAttach_delete(id) {
            var data = deleteObj('tAttach', id);
            return $q.when(data);
        }

        // ******************************
        //  TATTACHVISIBILITY - NUOVI METODI

        function tAttachVisibility_getAuth(tSourceCode) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });

            var data = getAllByParams('TAttach', 'TAttachVisibility_GetAuth', params);
            return $q.when(data);
        }

        function tAttachVisibility_getAll(tAttachId, roleId) {
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'tAttachId', value: tAttachId });
            params.push({ name: 'roleId', value: roleId });

            var data = getAllByParams('TAttach', 'TAttachVisibility_GetAllByFilter', params);
            return $q.when(data);
        }

        function tAttachVisibility_add(item) {
            return $http.post(urlAPI + '/TAttach/TAttachVisibility_Add', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed tAttachVisibility_add for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachVisibility_update(item) {
            return $http.put(urlAPI + '/TAttach/TAttachVisibility_Update', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed tAttachVisibility_update for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachVisibility_delete(id) {
            return $http.delete(urlAPI + '/TAttach/TAttachVisibility_Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed deleteObj for TAttach: %s', message);
                    return message.status;
                });
        }

        // ******************************
        //  TATTACHFILETYPE - NUOVI METODI

        function tAttachFileType_getAll(tAttachId, title, extension) {
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }
            if (typeof (title) == 'undefined') { title = ''; }
            if (typeof (extension) == 'undefined') { extension = ''; }

            var params = [];
            params.push({ name: 'tAttachId', value: tAttachId });
            params.push({ name: 'title', value: title });
            params.push({ name: 'extension', value: extension });

            var data = getAllByParams('TAttach', 'TAttachFileType_GetAllByFilter', params);
            return $q.when(data);
        }

        function tAttachFileType_add(item) {
            return $http.post(urlAPI + '/TAttach/TAttachFileType_Add', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed TAttachFileType_Add for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachFileType_update(item) {
            return $http.put(urlAPI + '/TAttach/TAttachFileType_Update_Update', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed TAttachFileType_Update for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachFileType_delete(id) {
            return $http.delete(urlAPI + '/TAttach/TAttachFileType_Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed deleteObj for TAttachFileType: %s', message);
                    return message.status;
                });
        }


        // ******************************
        //  TSOURCE - NUOVI METODI
        function tSource_getAllList() {

            var data = getAllList('tSource');
            return $q.when(data);
        }

        function tSource_getAll(order) {
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: 0 });
            params.push({ name: 'page', value: 0 });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tSource', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function tSource_get(id) {
            var data = getById('tSource', id);
            return $q.when(data);
        }

        function tSource_getByCode(code) {
            var data = getAllByParam('tSource', 'GetByCode', 'code', code);
            return $q.when(data);
        }



        // ******************************
        //  Funzioni Generiche
        function getAll(objName) {
            return $http.get(urlAPI + '/' + objName + '/GetAll')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllList(objName) {
            return $http.get(urlAPI + '/' + objName + '/GetAllList')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllNoParam(objName, actionName) {
            var url = urlAPI + '/' + objName + '/' + actionName;
            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll NO Param for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllByParam(objName, actionName, paramName, paramValue) {
            var url = urlAPI + '/' + objName + '/' + actionName + '?' + paramName + '=' + paramValue;
            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAll for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getAllByParams(objName, actionName, paramArray) {
            var url = urlAPI + '/' + objName + '/' + actionName;

            var numParams = paramArray.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += paramArray[i].name + '=' + paramArray[i].value;
            }
            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllByParams for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getById(objName, id) {
            return $http.get(urlAPI + '/' + objName + '/Get/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getById for %s: %s', objName, message);
                    return message.status;
                });
        }

        function getBaseById(objName, id) {
            return $http.get(urlAPI + '/' + objName + '/GetBase/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getBaseById for %s: %s', objName, message);
                    return message.status;
                });
        }

        function addObj(objName, objValue) {
            return $http.post(urlAPI + '/' + objName + '/Post', objValue)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        function updateObj(objName, objValue) {
            return $http.put(urlAPI + '/' + objName + '/Put', objValue)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed updateObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        function deleteObj(objName, id) {
            return $http.delete(urlAPI + '/' + objName + '/Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed deleteObj for %s: %s', objName, message);
                    return message.status;
                });
        }
        //  END - Funzioni Generiche
        // ******************************
    }
})();
